import React from "react";
import { connect } from "react-redux";
import { Button } from "../../Button";
import { Select } from "../../Input";
import Loading from "../../Loader/Loading";
import { Modal } from "../../Modal/index.js";
import rbcLogo from "../../../assets/rbc-logo.png";
import btdLogo from "../../../assets/btd-logo.png";
import bloodImg from "../../../assets/blood-cover.png";
import { getStorage } from "../../../utils/storage";
import api from "../../../utils/api";
import fetchBloodCenters from "../../../utils/queries/bloodCenterQuery";
import fetchAbcPlanning from "../../../utils/queries/abcPlanningQuery";
import { resolveConfig, loadConfigAsync, DEFAULT_MONTHLY_PLAN as MONTHS_WEEKS, DEFAULT_RDF_SECTIONS, DEFAULT_RNP_SECTIONS } from "./abcpConfig";
import { DAILY_PLAN_2026 } from './dailyPlan2026';
import { generateABCPExcel } from './abcpExcelExport';

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

// ─── Palette ──────────────────────────────────────────────────────────────────
const C = {
  headerBar:    "#2E75B6",
  centerGreen:  "#1F4E2D",
  centerGreen2: "#375623",
  totalColHdr:  "#C55A11",
  totalColAlt:  "#FCE4D6",
  weekSection:  "#FFC000",
  totalWeekRow: "#FFD966",
  totalWeek:    "#70AD47",
  perfWeek:     "#BDD7EE",
  totalMonth:   "#FFC000",
  fixedSite:    "#00B0F0",
  busRow:       "#FFFF00",
  noBlood:      "#595959",
  summaryTotal: "#70AD47",
  altRow:       "#F2F2F2",
  border:       "#AAAAAA",
  black:        "#000000",
  white:        "#FFFFFF",
};

// ─── Summary data ─────────────────────────────────────────────────────────────
const SUMMARY = [
  { month:"JANUARY",   kigali:[56,2619],  butare:[34,1302],  karongi:[33,1161],  ruhengeri:[43,1677],  rwamagana:[35,1302],  rcbtTotal:[201,8061],  rmth:[14,800],   rnp:[2,440],  grand:[217,9301]  },
  { month:"FEBRUARY",  kigali:[56,2619],  butare:[35,1363],  karongi:[32,1423],  ruhengeri:[42,1513],  rwamagana:[34,1300],  rcbtTotal:[199,8218],  rmth:[18,1571],  rnp:[3,240],  grand:[220,10029] },
  { month:"MARCH",     kigali:[51,2645],  butare:[29,1250],  karongi:[34,1349],  ruhengeri:[39,1463],  rwamagana:[36,1326],  rcbtTotal:[189,8033],  rmth:[20,1190],  rnp:[4,335],  grand:[213,9558]  },
  { month:"APRIL",     kigali:[45,2138],  butare:[34,1292],  karongi:[31,1141],  ruhengeri:[43,1607],  rwamagana:[34,1154],  rcbtTotal:[187,7332],  rmth:[14,800],   rnp:[4,410],  grand:[205,8542]  },
  { month:"MAY",       kigali:[64,3026],  butare:[35,1363],  karongi:[35,1509],  ruhengeri:[43,1616],  rwamagana:[38,1456],  rcbtTotal:[215,8970],  rmth:[18,1571],  rnp:[2,180],  grand:[235,10721] },
  { month:"JUNE",      kigali:[42,2344],  butare:[33,1381],  karongi:[34,1206],  ruhengeri:[39,1469],  rwamagana:[36,1339],  rcbtTotal:[184,7739],  rmth:[20,1190],  rnp:[4,335],  grand:[208,9264]  },
  { month:"JULY",      kigali:[39,2028],  butare:[29,1107],  karongi:[30,1176],  ruhengeri:[36,1348],  rwamagana:[39,1379],  rcbtTotal:[173,7038],  rmth:[14,800],   rnp:[4,560],  grand:[191,8398]  },
  { month:"AUGUST",    kigali:[40,2027],  butare:[33,1254],  karongi:[31,1012],  ruhengeri:[37,1439],  rwamagana:[33,1216],  rcbtTotal:[174,6948],  rmth:[18,1571],  rnp:[3,240],  grand:[195,8759]  },
  { month:"SEPTEMBER", kigali:[45,2353],  butare:[30,1214],  karongi:[30,1229],  ruhengeri:[38,1406],  rwamagana:[38,1342],  rcbtTotal:[181,7544],  rmth:[20,1190],  rnp:[3,275],  grand:[204,9009]  },
  { month:"OCTOBER",   kigali:[58,2752],  butare:[35,1371],  karongi:[34,1256],  ruhengeri:[43,1780],  rwamagana:[37,1457],  rcbtTotal:[207,8616],  rmth:[14,800],   rnp:[4,610],  grand:[225,10026] },
  { month:"NOVEMBER",  kigali:[59,2626],  butare:[39,1391],  karongi:[32,1384],  ruhengeri:[44,1684],  rwamagana:[36,1284],  rcbtTotal:[210,8369],  rmth:[18,1571],  rnp:[3,240],  grand:[231,10180] },
  { month:"DECEMBER",  kigali:[38,2322],  butare:[30,1325],  karongi:[32,1329],  ruhengeri:[42,1660],  rwamagana:[38,1380],  rcbtTotal:[180,8016],  rmth:[20,1205],  rnp:[3,275],  grand:[203,9496]  },
];
const SUMMARY_TOTAL = {
  kigali:[593,29499], butare:[396,15613], karongi:[388,15175], ruhengeri:[489,18662],
  rwamagana:[434,15935], rcbtTotal:[2300,94884], rmth:[208,14259], rnp:[39,4140], grand:[2547,113283]
};

const PLANNED_SITES_2026 = {
  JANUARY: {
    1: {
      k: ["Murambi", "Mugambazi", "Bwisige", "Nyabushingitwa", "Muhura", "Muhondo", "Huro", "Cyeza"],
      b: ["Miko", "Gahana"],
      ko: ["EPR", "Mataba"],
      ru: ["Gikokwe", "Mataba", "Bisate Kinig", "Karambo", "Rutovu"],
      rw: ["Gahengeri", "Mining", "Muhazi", "Murambi"],
    },
    2: {
      k: ["Mushishiro", "Kabadaha", "Kamabuye", "Mageragere", "Mines", "Muyumbu", "Murehe", "Byumba", "Karenge", "Mwendo", "Kayenzi", "Kiyumba", "Remera", "Paroisse", "Gahanga", "SDA Kanombe"],
      b: ["Nyanza", "Gasaka", "Mututu", "Gasarenda", "ADE"],
      ko: ["Gakeri", "Murundi", "Munzanga", "Mugonero", "Tyazo", "Kibogora", "Gihombo", "Nyamasheke", "Macuba", "Gatare", "Rusebeya"],
      ru: ["Byangabo", "Busogo", "Kora Bigogwe", "Gikokwe", "Mataba", "Kanyirarebe", "Karukoko", "Camp I", "Camp II"],
      rw: ["PRODEV", "Rwamagana", "Rubona", "Kibungo L2TH", "Gahima", "Kibungo", "Ruramira", "Karambi", "Murundi", "Mukarange", "Catholic"],
    },
    3: {
      k: ["Nyamiyaga", "Kidahwe", "Bugesera", "Mwendo", "Ruhuha-Ruhuha", "TVET Mukarange", "Runda-Gihara", "Kinazi-Kinazi", "Jarama-Jarama", "Cyeza-Rutobwe", "JAM-Shyogwe", "ETEKA Kabgayi", "E.S Mu", "TTC de la Salle", "Nyarusange", "Nyarusa", "Karama-Norvege"],
      b: ["ADE", "Cya"],
      ko: ["Busoro", "Rug", "Kib", "Birambo", "Nya", "CFOPRORU", "ESA", "Gikonko", "Esp", "TSS", "Rub", "ES M"],
      ru: ["Goico Ca", "PAN", "TSS AP"],
      rw: ["Town", "Kinoni", "Camp II APENA", "AG TSS", "Nyakarambi", "Kirehe", "Camp II Kigarama", "Mucaca", "Shwemu II", "TSS", "APEFOC", "ARPE TSS", "ESTB", "SOGO"],
    },
    4: {
      k: ["Kisaro-Kisar", "Cyumba-Cyumba", "Nyarugenge", "Nyamata TSS", "Rulindo Mushon", "TVET Mulind", "Ngororero Rusu", "TTC Muhanga", "St Etienne", "Shyogwe", "Shyorongi Rwah", "Sake-Sake", "Paroise-Kanomb", "SDA Nyamirambo"],
      b: ["Kav", "Kami", "Cya", "Nto"],
      ko: ["Viro", "Kareba", "TSS", "Nshiri", "SPANYA M", "TTC", "Save", "Kizibere"],
      ru: ["Karambi Ka", "S Mugonero", "TSS GS", "Kin", "GS IB", "Runab", "Geo", "S Bumba", "TSS", "TTC N", "Muram", "RTC", "Muk", "Gat"],
      rw: ["Rwimiyaga", "SIR TSS Nyakigando", "BK TSS", "Hindiro", "Kiyombe", "UKA TSS", "Butaro", "RP Gishari", "S Kinigi", "Mount Meru", "TSS", "Remera", "Nyundo Bugarura"],
    },
    5: {
      k: ["Rugendabari", "Kanyana", "KinihiraTVET", "E.S Bulinga", "APAPEDUC", "Bungwe", "Butamwa", "College", "Miyove", "G.S Kabuga", "Nyabikenke", "TSS", "G.S Karenge", "Muyumbu Murama"],
      b: ["Mbuye", "ETI Save"],
      ko: ["ES Murunda"],
      ru: ["Kigeyo", "S Mushubati", "TSS", "P Rutsiro", "S NYANGE", "ETEFOP"],
      rw: ["CAVM", "Mutenderi", "Bare", "ASPEJ", "Mukarange", "Center for", "Ngoma", "Nyamugali", "Gikaya", "Vocational"],
    },
  },
  FEBRUARY: {
    1: {
      k: ["Regina Pacis", "Paroisse"],
      b: [],
      ko: [],
      ru: [],
      rw: ["Paroisse", "Rwamgana"],
    },
    2: {
      k: ["Kigese-Kigese", "Rongi-Mbuye", "Rweru", "Nkanga", "Bushoki", "Gasiza", "Karama", "Kabacuz", "Buramb", "Gashora", "Ruhunde", "Rutunga", "Mwogo", "St Ignace", "Rusumo", "E.S Rutobwe", "Mugina-TSS", "Paroisse", "Kicukiro", "Minazi", "Munyana"],
      b: ["CXR", "Nyaruguru", "ES Mamba", "GS Kibyagira", "Lycee", "Nyanza", "Kiyonza", "GS Cyarwa", "Simbi", "Kamwambi", "Rugogwe"],
      ko: ["Cyinama", "Bisesero", "APAKAPE", "GS Kavumu", "Bitenga", "Kajugujugu", "EAV Kivumu", "GSFAK"],
      ru: ["Kabumb Bugesh", "Kidaho Camp I", "GS Mutura I", "Kanzenze", "Kidaho Camp II", "Rusasa Kivuye", "St Martin", "Gisenyi", "MahokoKan", "Camp I", "BuringoBugeshi", "Mahoko Kan", "Camp II", "Ecole d'Art", "Nyundo", "GS Rambura", "Filles"],
      rw: ["Rwimiyaga", "Shonga", "Cyabayaga", "Mimuli", "Gikagati", "Runyinya", "Gishororo", "Matimba", "Gatunda"],
    },
    3: {
      k: ["Ruvune", "Kabare", "Rukozo", "Byimana", "APEKI Tumba", "Gishaka", "Inyange", "Ngororero", "Ruvun-Reber", "Muhanga TC", "E.S Kinazi", "TSS", "EFA", "Nyagahanga", "APAPEC", "Murambi", "Ntongwe", "Nyakabungo", "Muyongwe", "Runzenze"],
      b: ["Migina", "Buhimba", "Uwinkomo", "Sekera", "ES Nyanza", "ES Kigembe", "Kimirama", "TTC Mbuga"],
      ko: ["Saint Paul", "Tyazo", "ES Tyazo", "Karengera", "Biguhu", "ES urumuri", "IPK", "Sainte Marie", "Kibuye"],
      ru: ["Rwaza Rwaza", "CF Sina Gerard", "Rega Bigogwe", "Kareba Jenda", "Kampanga", "Gitare Kagogo", "GS NDA Nyundo", "TTC Gacuba II", "Janja Janja"],
      rw: ["Nyange", "Rukara", "Rwimishi", "Muhazi", "Gishari", "Garden TSS", "Gihinga", "Christopher", "Rurama", "Gitwe", "Islamic", "Protest", "Rwamgna", "Lycee Zaza"],
    },
    4: {
      k: ["Mugina", "Kabuga", "Mukama", "Gihengeli", "ACEJ Karama", "Nyarurenzi", "Ngeruka", "Murama", "Muhondo", "Ngamba", "Kazirabonde", "Kamonyi", "Mutete", "Gaseke", "Giti-Kabacuzi", "Cyeza-Kivumu"],
      b: ["Kaduha", "ES Nkomero", "ES Save", "Kitabi"],
      ko: ["Giheke", "Es Gafunzo", "Giheke TSS", "GS Muganza", "TSS", "Mibirizi TSS", "Gihundwe", "Mizero TSS", "TTC Mwezi", "EAV", "Ntendezi", "Tyazo TSS"],
      ru: ["Buhengeri", "Busasamana", "Hindiro TSS", "Hindiro", "Rwili Muhanda", "Cyabingo", "Muringa TSS", "Muringa", "GS Muramba", "Kabona", "Rusarabuye", "Kibihekane TS", "Kibisabo TSS"],
      rw: ["St Vincent", "Paul", "Kabarondo", "Gituza", "GS St Aloys", "Gakoni", "Adventiste", "Cyinzovu", "Gishanda"],
    },
    5: {
      k: ["Kageyo", "Muhondo", "Juru", "Kabukuba", "Nyamirambo", "Miduha", "Rukumberi", "Rukumb", "Muyumbu", "Nyamabuye", "Nyamabu", "Kinazi Rutabo", "Buyoga", "Busoro", "Gatsibo", "Nyagahanga", "TVET", "Nyakabanda"],
      b: ["Mukingo", "ESEKI", "EAV", "Kabutare", "Mugombwa", "Gitisi TSS", "Rebero", "Ntongwe", "CS Kigoma", "Kizi", "Ruyenzi"],
      ko: ["Muyira", "Rwamiko", "St Joseph", "Birambo", "GS Kirinda", "ES Kirinda", "GS Congo", "Nil", "Rwingongo", "Mukura", "Ryan", "Gash", "Gasiza R"],
      ru: ["Shingiro Shingiro", "Bugeshi Bugeshi", "Rusasa Kivuye", "UGHE", "RP Musanze", "MIPC", "Kiga", "Rwama"],
      rw: ["Zaza", "UR Rukara", "Kiziguro"],
    },
    6: {
      k: [],
      b: ["GSOB"],
      ko: ["ESc", "Sit", "SIT"],
      ru: ["Gisenyi"],
      rw: [],
    },
  },
  MARCH: {
    1: {
      k: ["Mayange"],
      b: [],
      ko: [],
      ru: [],
      rw: ["Agahozo"],
    },
    2: {
      k: ["Ngamba", "Musenyi", "Rusiga Rusiga", "Kageyo TSS", "Rukoma", "Remera", "Mukarange", "Mugina", "Shangasha", "Kajyanjyali", "E.S", "Nyakabanda", "Buyoga", "Gitumba", "Masaka", "Rusheshe"],
      b: ["Imberabyom", "Camp", "Ruramba", "GS Rwamiko", "Mironzi", "GS Butare", "Cath", "Karama"],
      ko: ["Bwishyura", "Nyabidahe", "Gasenyi", "Kirambo", "Gitesi", "GS St Joseph", "Nyamasheke", "Munigi", "Twumba", "St Martin", "Hanika", "Gisyita Shya", "Biruyi"],
      ru: ["Gatonde", "Mugunga", "GS Kanama", "Gatonde TSS", "Rugarama", "GS Nemba", "Nemba TSS", "ES Nyaruto", "Nemba", "ESc Musanz", "ES Kagogo"],
      rw: ["Karambi", "Nyagatare", "SOPEM", "Rukomo", "Nyagatare SS", "Karama", "Mutumba"],
    },
    3: {
      k: ["Sancta Maria", "Mpanda TSS", "Kageyo", "Ruli Ruli", "Rukom", "Mwirute", "Shyara Gihinga", "Karenge", "Mwendo", "Mutara", "Rushaki", "Kayenzi", "Nyakaliro", "Bihembe", "GicumbiTSS", "ADEPR", "Kimihurura", "Nyinawimana"],
      b: ["Rurangazi", "UR Huye", "Buhanda", "IPRC Huy", "GS Ntong", "Rwanza"],
      ko: ["Tyazo", "Kibogora", "Gashari", "Birambo", "Shyembe", "Rugote", "Bigugu", "Rugabano", "Rufungo", "Gisiza", "EPR", "RUBENGERA"],
      ru: ["Gihorwe", "Kabatwa", "CBS", "Kinigi", "Karwasa", "Gacaca", "ETAG", "Bihe Bugeshi", "Rwanzeku", "College", "Gisenyi"],
      rw: ["Mutenderi", "Sakara", "Rugarama", "Ntunga", "Camp", "Kabarondo", "Kayonza", "Murambi", "Gisenyi", "Rwamagana"],
    },
    4: {
      k: ["UNILAK", "Bumbog TVET", "Bumbogo", "BukureBitsibo", "Runda Gihara", "Rutare", "Jarama Jarama", "Rongi Ruhango", "Mount Kigali", "E.S Muhororo", "TTC de la Salle", "SDA Kanombe", "Kinihira"],
      b: ["Musebeya", "Butansin", "Nyarutej", "Karambi", "Ruhango", "Camp", "Masizi", "Gafumba", "Ndora", "CS Kibirizi", "Mbuye", "Gakoma"],
      ko: ["Rutsiro Tea", "Factory", "Murundi", "Munzanga", "Kibuye town", "Camp", "Kamembe"],
      ru: ["Gahunga", "Kabaya C", "Kabere M", "Kinanira", "Kabaya", "Gitebe", "Muringa", "Gitanga", "Ruhunde", "Tero", "Musanze", "ETK", "Karuganda", "Rambura", "Garcon"],
      rw: ["Mpanga", "Nyabubare", "Nganda", "Nyarubuye", "Nyabitare", "Gashongora", "Mahama", "Mushikiri", "Gahara", "Adve", "Kigonge", "UNILAK"],
    },
    5: {
      k: ["Muko Muko", "Rushashi", "Kageyo", "Ruli Gitega", "Ruhuha", "Nzige Nzige", "Ngeruka", "Twimpala", "Tumba Tumba", "Grand", "Seminaire", "Philo", "Nyamiyaga", "Kagamba", "Masaka"],
      b: [],
      ko: ["Gihombo", "Kibingo", "Murunda", "Hosp", "Rugabano", "Musasa", "Gisiza", "Boneza", "Kinunu", "Kayove", "SDA Syiki"],
      ru: ["Mubuga", "Muzo", "Kinigi Ca", "Gasiza", "Rambura", "Jenda Je", "Rwankeri", "Mukamira", "Gasiza Cyu", "APICUR", "Murambo", "Janja"],
      rw: ["Rwimbogo", "Rubona", "UR Rwamaga", "Karembo", "Kayonza", "Nyamirama", "Fumbwe"],
    },
    6: {
      k: ["Bungwe"],
      b: ["Ruheru"],
      ko: ["Bushenge", "Mwezi", "Nyakabuye", "Hosp"],
      ru: ["Masha", "Cyabingo", "Gakenke"],
      rw: ["Kabeza", "Kirehe", "Nyamugali"],
    },
  },
  APRIL: {
    1: {
      k: ["Ngoma", "Remera", "Rilima", "Nyabagendwa", "Murambi", "Mugambazi", "Bwisige", "Nyabushingit", "Muhura"],
      b: ["Ntyazo", "Gatunda", "Mukindo", "Miko"],
      ko: ["Nzahaha", "Rwimbogo", "Bugarama", "Cite", "Mibirizi", "Nyakarenzo", "Muganza", "SDA Kayenzi"],
      ru: ["Bisate Kinigi", "Kamubuga", "Gifurwe", "Rugengabar", "Kinyababa", "Base Camp", "Gikokwe", "Mataba"],
      rw: ["Mimuli", "Nyagashanga", "Musheri"],
    },
    2: {
      k: ["Mushishiro", "Kabadaha", "Kamabuye", "Muyumbu", "Murehe", "Byumba", "Kibangu", "Paroisse", "Huro", "Cyeza"],
      b: ["Busoro", "Gasaka", "Mututu", "Gasarenda", "Con", "Gahana", "Nyanza"],
      ko: ["Nyamasheke", "Gihombo", "Rubengera", "Kibirizi", "Mushubati", "Gisovu Tea", "Factory", "Nil"],
      ru: ["Murandi", "Remera", "Kanyirareb", "Gahunga", "Kora Bigog", "Nyanga", "Kinoni", "Mucaca", "Rugengabar", "Byangabo", "Busogo", "Kabatwa", "Kivuruga", "Busengo"],
      rw: ["Cyabayaga", "Kiyanzi", "Kirehe-Kigarama", "Nyakarambi", "Karambi", "Murundi", "Gatore", "Mugesera"],
    },
    3: {
      k: ["Nyam", "Rwahi", "Ntongwe"],
      b: ["Mug", "Hos", "Nyanza", "Gak", "Mushubi", "Mbu", "Lycee de", "Ruhango", "Mub", "Musha", "ADEPR", "Cyarwa"],
      ko: ["EPR", "Gitega"],
      ru: ["Kinogo", "Busasamana", "Karukoko", "Camp I", "Camp II", "Shyira DH", "Goico Camp", "Bushoki", "Nyamugari", "Nemba", "Goico", "Camp", "Kirambo", "Rusarabuye", "Harvest", "Church"],
      rw: ["Kiramuruzi", "Nyakigando", "Cyarubare", "Mugera", "Ruramira", "Zipline", "Agri value", "Paroisse", "Kibungo"],
    },
    4: {
      k: ["Bulinga", "PEDUC", "Kinazi", "Murama", "Shyogwe"],
      b: ["Viro", "Kareba", "Kavumu TSS", "Rwintama", "Gatunda", "Nshiri", "Karambi", "ESPANYA", "Kamirabagenzi", "GS Nyagasozi", "TTC Save"],
      ko: ["Kibogora", "Hospital", "Gatare", "Ruhango", "Nyange", "Gakeri", "Macuba", "Syiki", "Nyamasheke", "Kagano"],
      ru: ["KinkwarC", "Nyamugar", "Nemba", "Gisenyi", "Gikokwe", "Mataba", "Rusumo", "Butaro", "ETEFOP", "Kamina", "Busengo"],
      rw: ["Steel Rwa", "KTMD", "Camp", "Bella Inc", "Ndego", "Kibungo Rubona", "Munyaga", "Musha", "Remera", "Bugarura"],
    },
    5: {
      k: ["Nyamiyaga", "Kisaro Kisaro", "TVET", "Butamwa", "College", "Miyove", "S Kabuga", "TSS", "S Karenge"],
      b: ["Cyabakamyi", "Gishari", "GS Kizibere", "Kabuga", "ES Murama", "Munanira"],
      ko: ["Rubengera", "II TSS", "Kibirizi", "Umucyo", "Karengera", "ESAPAN", "Esperence", "TSS"],
      ru: ["Rushara", "Nemba", "ESIR TSS", "RTC Rubavu", "Gatovu TSS", "Kintobo", "EL Gatovu", "UR-CAVM"],
      rw: ["Ndego I&II", "Rwikiniro", "GS Munini TSS", "Kayonza Modern", "Nyagahandagaza", "Rwanteru", "Rusumo"],
    },
  },
  MAY: {
    1: {
      k: ["SDA", "Nyamirambo", "Regina Pacis"],
      b: ["ET Save"],
      ko: ["ADEPR", "Nyamakoro"],
      ru: ["TTCGacuba2", "ESTBusogo", "Kabona", "Rusarabuye"],
      rw: ["Agahozo"],
    },
    2: {
      k: ["Cyumba", "Kigese-Kigese", "Nyamata", "TSS", "Rulindo", "Mushongi", "TVET Mulindi", "TTC Muhanga", "St Etienne", "Shyogwe", "Mwogo Mwogo", "Sake Sake", "Musambira", "Gasange", "E.S Rutobwe", "Muyongwe", "Minazi", "Munyana"],
      b: ["CXR", "Nyaruguru", "ES Mamba", "GS Kibyagira", "Lycee", "Nyanza", "Kiyonza", "Cyarwa", "Simbi", "Kamwambi", "Kitabi"],
      ko: ["Nyamasheke", "Karambi", "Mburabuturo", "Ngoma", "Rugabano", "GS St Joseph", "Cyimbiri", "Rwinyoni", "GS Bumba TSS", "GSFAK"],
      ru: ["Kabumba", "Bugeshi", "St Martin TSS", "George Fox", "Butaro", "Kidaho", "Camp I", "KidahCamp", "Hindiro", "Buhengeri", "Busasamana", "CF Sina", "Gerard"],
      rw: ["Rushenyi", "Rugoma", "APENA", "Mutenderi", "Bare", "ASPEJ", "Center for", "Champion", "Ngoma", "Nyamugali", "Gikaya", "Ngarama"],
    },
    3: {
      k: ["Ngamba", "Musenyi", "Rugendabari", "Kanyana", "Mugina Kabuga", "ACEJ Karama", "Ruli Ruli", "APEKI Tumba", "Inyange", "Ngororero", "Muyumbu", "Ruhunde", "Rutunga", "Kinazi Rutabo", "Mugina St", "Ignace", "Murama", "Mutete Gaseke", "MuginaTSS", "APAPEC", "Murambi", "Giti Kabacuzi", "Masaka", "Rusheshe"],
      b: ["Migina", "Buhimba", "Uwinkomo", "Sekera", "ES Nyanza", "ES Kigembe", "Kimirama", "TTC Mbuga"],
      ko: ["Kigeyo B", "Vumbi", "Buhindure", "UMBA TSS", "CP Rutsiro", "GS Mushubati", "ES MUBUGA"],
      ru: ["Musanz", "Kareba", "Muring", "ETAG", "Kinyab", "Rusasa", "Ibuka", "Kabay", "GS NDA", "Nyundo", "GS Ram", "Filles"],
      rw: ["Rwimiyaga", "Jenda", "Shonga", "Cyabayaga", "Mimuli", "Runyinya", "Gishororo", "Kivuye", "Gatunda"],
    },
    4: {
      k: ["Rongi Mbuye", "Kabare", "Bugeser", "Mwendo", "Nyarurenzi", "Kinihira TVET", "Nyamirambo", "Miduha", "Karama Karama", "Kabacuzi", "Buramba", "Gashora", "Ngamba", "Kazirabonde", "Mugina", "Rilima", "Nyabagendwa", "Gatumba", "Rusumo", "Gatsibo", "Nyagahanga", "Kamonyi", "Paroisse", "Cyeza", "Kivumu"],
      b: ["Kaduha", "ES Nkomero", "ES Save", "ADEPR"],
      ko: ["Bisesesero", "Karengera", "Gitwa", "St Paul", "Tyazo", "APAKAPE", "Es Tyazo", "GS Marie", "Reine", "Congo Nil", "EAV Kivumu", "Tyazo TSS"],
      ru: ["Cyabingo", "Rwili", "Muhanda", "GS Muramba", "Hindiro", "RP Musanze", "Remera", "INES", "Ruhengeri I", "Bugeshi", "Kanzenze TSS", "TSS", "Janja"],
      rw: ["Gahini", "Rukara", "Rwimishinya", "Muhazi", "Gishari", "Garden TSS", "Gihinga", "Christopher", "Rurama", "Gitwe", "Islamic", "Protestant", "Adventist"],
    },
    5: {
      k: ["Rukozo", "EFA", "Nyagahanga", "Byimana", "Mukarange", "Nyamata", "Rutare Rutare", "Ruvune Rebero", "Shangasha", "Kajyanjyari", "TVET", "Nyakabanda", "E.S KinaziTSS", "Paroisse", "Nyamirambo", "Masaka"],
      b: ["Mukingo", "EAV", "Kabutare", "Mugombwa", "Gitisi TSS", "GSRuhango", "Cath", "ESEKI", "Kizi", "GS Ruyenzi", "E Sc Nyanza"],
      ko: ["Giheke", "Gafunzo", "TTC Mwezi", "Muko", "Mibirizi TSS", "Giheke TSS", "Mizero TSS", "EAV", "Ntendezi", "Ste Marie", "Kibuye"],
      ru: ["Shingiro", "GS Kamubuga", "MIPC", "UGHE", "Ruhehe", "Gataraga", "Hindiro TSS", "Hindiro", "Ryabizige", "Cyanzarwe", "Ec d'Art", "Nyundo", "ES Nyarutovu"],
      rw: ["St Vincent de", "Paul", "Vocational", "ES Kabarondo", "Gituza", "St Aloys", "Gakoni", "Adventist", "Nyabisindu", "Cyinzovu", "Gishanda"],
    },
  },
  JUNE: {
    1: {
      k: ["Kageyo", "TSS", "Ruhuha", "Nzige", "Mpanda TSS", "Karenge", "Mwendo", "Mutara", "Kayenzi", "Nyankenke", "Yaramba", "Buyoga", "Gitumba", "Mayange"],
      b: ["Imberabyombi", "ES Higiro", "GS Rukira", "Ruramba", "GS Rwamiko", "Mironzi", "Nyamagab TSS", "E Sc", "Nyamagabe", "Karama"],
      ko: ["Kavumu", "Rwingongo", "ES Kirinda", "GS Cyinama", "Kajugujugu", "Murunda", "St Francois", "Shangi"],
      ru: ["Gatonde", "Muganga", "Masha", "Cyabingo", "GS Kanama", "Kanama", "Nemba TSS", "TSS", "Kinyababa", "College de", "Gisenyi", "Murambo", "Janja"],
      rw: ["Kabeza", "Kirehe", "Nyamugali", "Mulindi", "Mimuli", "Nyagashanga", "Musheri", "Kirwa"],
    },
    2: {
      k: ["UNILAK", "Rusiga-Rusiga", "San Maria", "Kamonyi", "Kageyo", "Runda-Gihara", "Muhondo", "Jarama-Jarama", "Cyeza", "Rutobwe", "BumbogoTVET", "E.S", "Nyakabanda", "Gicumbi", "TSS", "Kinihira", "Nyinawimana"],
      b: ["Rurangazi", "Huye", "UR Huye", "Buhanda", "Rebero ES", "Ntongwe Mu", "Gasarenda", "Rwanza", "Musebeya"],
      ko: ["Bwishuyra", "Nyabidahe", "Gasenyi", "Nyarubuye", "IPK", "Urumuri", "EPR"],
      ru: ["Gihorwe", "Kabatwa", "GS Mutur I", "Kanzenz", "Bihe Bugeshi", "APEFOC", "Mutobo TSS", "Busogo", "Runaba", "Butaro", "CBS Kinigi", "ES Kirambo"],
      rw: ["Mutenderi", "Nyakarambi", "Kiyanzi", "Kirehe", "Kigarama", "Sakara", "Gatore", "Murundi"],
    },
    3: {
      k: ["Muko", "Muhanga TC", "Rukoma", "Remera", "Nyamabuye", "Bumbogo", "Ngeruka", "Twimpala", "Rongi Ruhango", "Rushaki", "Nyakaliro", "Bihembe"],
      b: ["Butansinda", "Nyaruteja", "Karambi", "Ruhango M", "Camp Rw", "Ruhango", "Camp"],
      ko: ["ETKar", "A Gitovu", "Gishy"],
      ru: ["Kinogo", "Busasamana", "GS Kabatwa", "Gitebe", "Muringa", "CBK TSS", "Kabere Muko", "ESIR TSS", "Kinanira", "Kabaya", "Tero", "Musanze", "Gahara", "Busengo"],
      rw: ["Mpanga", "Nganda", "Nyabitare", "Gashongora", "Mahama", "Mushikiri", "Mugera"],
    },
    4: {
      k: ["Rushashi", "Kageyo", "Bukure", "Bitsibo", "Shyara", "Gihinga", "Buyoga", "Busoro", "Mount", "Kigali", "Nyamiyaga", "Juru", "Kabukuba"],
      b: ["Masizi", "Tea", "Mur", "Munz", "Ndora", "CS Kibirizi", "ES Sumba", "Kibuy", "Mbuye", "Kayov", "Kibu", "Syik", "Gakoma"],
      ko: ["Factory", "CAMP"],
      ru: ["Mubuga", "Muzo", "Kabaya Camp", "Gahunga", "Kinyababa", "Busasamana", "Gakenke", "Harvest", "Church"],
      rw: ["Rwimiyaga", "Nyakigando", "Kiyombe", "Cyabayaga", "RP Ngoma", "RP Gishari", "Mount", "Meru", "Remera", "Bugarura"],
    },
    5: {
      k: ["Ruli", "Gitega"],
      b: ["Muru", "Ruga"],
      ko: [],
      ru: ["Kinkware", "Camp I", "Camp II", "Gitanga", "Ruhunde"],
      rw: ["Ntunga", "Kabarondo", "Murambi", "Gisenyi"],
    },
  },
  JULY: {
    1: {
      k: ["Murambi", "Mugambazi", "Bwisige", "Muhondo", "Huro", "Cyeza Cyeza", "Mushishiro", "Kabadaha"],
      b: ["Ntyazo", "Gatunda", "Mukindo", "Miko", "Gahana"],
      ko: ["Musasa", "Gisiza", "Boneza", "Kinunu", "Gihombo", "Kibingo", "SDA", "Syiki"],
      ru: ["Gifurw", "Rugengabr", "Shyira DH", "Byangabo", "Busogo", "Kabatwa", "Karambo"],
      rw: ["Karembo", "Kayonza", "Nyamirama", "Fumbwe"],
    },
    2: {
      k: ["Mageragere", "Mines", "Muyumbu", "Murehe", "Byumba", "Tumba", "Rwahi", "Paroisse", "Gahanga", "ADEPR"],
      b: ["Nyanza", "Camp", "Gasaka", "Mututu", "Rugogw"],
      ko: ["Bushenge", "Mwezi", "Nyakabuye", "Gihundwe", "Hospital", "Nzahaha", "Rwimbogo", "Bugarama", "Cite", "Mibirizi", "Nyakarenzo"],
      ru: ["Murandi", "Remera", "Gasiza", "Rambura", "Bisate Kinig", "Nyamugari", "Nemba", "Nyirangaram", "Bushok", "Kanyirareb", "Gahung", "Bugarama Ka", "Muganza c", "SDA", "Kayenzi"],
      rw: ["Bushara", "Rwempasha", "Rugarama", "Nyagatare", "Murama", "Rukira", "Rukomo", "Shimwa", "Polo", "Karama", "Mutumba"],
    },
    3: {
      k: ["Gicaca", "Kinazi", "Remera", "Gatsibo"],
      b: ["Busoro", "Biramb", "Kinwet", "Mushub", "Gikonk", "Musha", "ADEPR Cyar"],
      ko: [],
      ru: ["Gihombo Ny", "Nyamasheke", "Mugonero", "Hospital", "Tyazo", "Kibogora", "Hospital Ru", "Congo Nil", "ADEPR", "Nyamakoro Ki"],
      rw: ["Kinoni", "Rwimbogo", "Rwamagana", "Rubona", "Kamubuga", "Gasetsa", "Mataba", "Kibungo", "Mucaca", "Ruramira", "Gahengeri", "Nemba Mining", "Kirambo", "Mining", "Shyira"],
    },
    4: {
      k: ["Kivuye Kivuye", "Mukama", "Gihengeli", "Ngororero", "Rususa", "Rukoma", "Mwirute", "Kaniga Mulindi", "AUCA Masoro", "Kepler", "SDA", "Kanombe", "Remer Healin", "Church"],
      b: ["Viro", "Kareba", "Rwintama", "Ruyenzi", "Kamirabagenzi", "ADEPR", "Matyazo"],
      ko: ["Karon", "Tea Fac", "Gisovu", "Facto", "Rubenge", "Kibir", "Mubuga", "Kamembe", "Cite", "Camp", "KamembC", "Cam"],
      ru: ["Tea", "Gisenyi Camp", "Mukamira", "Ndabanyurahe", "Nyange", "Rutake Janja", "Kinoni Kinon", "Kamina", "Busengo"],
      rw: ["Kabarondo", "Camp", "Muhazi", "Murambi", "Nyakarambi", "Rwamagana", "Nyinya", "Rushenyi", "Kayonza", "Gatunda", "Mukarange", "Cath"],
    },
    5: {
      k: ["Rukozo", "Bungwe", "Muhondo", "Kibangu", "ICK Kabgayi"],
      b: ["Cyabakamyi", "Gishari", "Nyamahwa", "Munanira", "Kimirama"],
      ko: ["Gatare", "Ruhango", "Murund", "Mburama", "Mushubati", "Rusebeya"],
      ru: ["Kinogo", "Busasamana", "Kora", "Bigogwe", "Buringo", "Bugeshi", "Gikokwe", "Mataba"],
      rw: ["Kiramuruzi", "Kinteko", "PRODEV", "Cyarubare", "Kibungo", "L2TH", "Ndego", "Munyaga", "Steel Rw", "KTMD"],
    },
  },
  AUGUST: {
    1: {
      k: ["SDA", "Regina Pacis"],
      b: ["ADEPR", "Taba"],
      ko: ["EPR", "Mataba"],
      ru: [],
      rw: ["Paroisse", "Kibungo"],
    },
    2: {
      k: ["Kivuye", "Bushoki", "Gasiza", "Kabacuzi", "Buramba", "UR CST", "Kinazi", "Rutabo", "Gatumba", "Rusumo", "Muyongwe", "Paroiss", "Nyamiramb", "ADEPR", "Kanombe"],
      b: ["CXR", "Nyaruguru", "Imberabyom", "Imberabyombi", "Ruramba", "Kabuga", "Kiyonza", "Vunga", "Simbi", "Kitabi"],
      ko: ["Kibuye Hosp", "Kivu Watt", "Kirinda", "Hospital", "Karongi", "Pension Plaza", "Kibogora", "Polytechnic", "Kajugujugu", "Nyamasheke", "Kagano"],
      ru: ["Goico", "Camp I", "RusasaKivuye", "Goico Camp I", "Shyira DH", "Mahoko", "Kabumba", "Bugeshi", "Gitare Kagog", "Kabashumb", "Kintob", "Jomba"],
      rw: ["Rwimbogo", "Kabeza", "Kirehe", "Nyamugali", "Mulindi", "Mimuli", "Nyagashanga", "Musheri", "Kirwa"],
    },
    3: {
      k: ["Bungwe", "Byimana", "Muyumbu", "Gashora", "Mugina", "Kabuga", "Gasange", "Giti Kabacuzi", "Magerage", "Runzenz"],
      b: ["Migina", "Buhimba", "Gatunda", "Nshiri", "Rebero", "Ntongwe", "Gasarend", "Rwanza"],
      ko: ["Twumba", "Gakuta", "Muyange", "Nyabitekeri", "Ruharambuga", "Macuba", "Gatare", "Karengera", "Kirimbi", "Shagasha Te", "Factory"],
      ru: ["Kareba Jend", "Buhenger", "Busasaman", "Bugeshi", "CS Shingir", "Shingiro", "Musanze"],
      rw: ["Mutenderi", "Nyakarambi", "Kiyanzi", "Kirehe", "Kigarama", "Mpanga", "Sakara", "Gatore", "Karambi", "Murundi", "Adventist", "Kigonge", "UNILAC"],
    },
    4: {
      k: ["AUCA", "Gishushu", "Mageragere", "Nyarurenzi", "Karama", "Nyamabuye", "Ngamb", "Kazirabonde", "Mugina", "Ntongw", "Paroisse", "Kicukiro", "Minazi", "Munyana"],
      b: ["Rurangaz", "Butansin", "Buhanda", "Nyarutej", "Mironzi", "Ruhango", "Masizi"],
      ko: ["Gakeri", "Gashari", "Birambo", "Shyembe", "Rugote", "Rugaba", "Rugabano", "PUR Karongi", "Gisiza", "EPR", "Gitega"],
      ru: ["Kinogo", "Busasamana", "Base Camp", "Ryabizige", "Cyanzar", "Karwasa", "Gacaca", "Base camp II", "Gahunga", "Tero Musa", "Rugarama", "Muramba", "Janja"],
      rw: ["Nganda", "Nyabitare", "Nyarubuye", "Mahama", "Mushikiri", "Mugera", "Gahara"],
    },
    5: {
      k: ["Nyakaliro", "Rushashi", "Kageyo", "Ruli", "Rutare", "Shyara", "Gihinga", "Mutete", "Gaseke", "AEBR Kacyiru", "Shyorongi", "SDA", "Kimisagara"],
      b: ["Gafumba", "Ndora", "CS Kibiri", "Mbuye", "CS Kigoma", "Gakoma"],
      ko: ["Nyamasheke", "Karambi", "Murundi", "Munzanag", "Rutsiro Te", "Factory", "Nyange", "Kibuye Cam", "Kibuye", "Camp", "Syiki", "EPR"],
      ru: ["Kabatwa", "Kabaya Ca", "Busasamana", "Kabere Muko", "Kinyababa", "Kinigi Ca", "Masha", "Cyabingo", "Busengo", "Janja Jan"],
      rw: ["Rwimiyaga", "Nyakigando", "Kiyombe", "RP Ngoma", "RP Gishari", "Mount", "Meru", "Remera"],
    },
    6: {
      k: ["Juru", "Kabukuba"],
      b: ["Ruheru"],
      ko: ["Murunda", "Hospital"],
      ru: ["Rwankeri", "Mukamira"],
      rw: [],
    },
  },
  SEPTEMBER: {
    1: {
      k: ["Ruli Gitega", "Nzige", "Buyoga", "Busoro", "Gitumba", "Masaka Rusheshe", "Nyinawimana"],
      b: ["Kiruhura", "Ntyazo", "Karambi", "Miko", "Gahana"],
      ko: ["Rugabano", "Musasa", "Gisiza", "Boneza", "Kinunu", "Gihombo", "Kibingo", "Biruyi"],
      ru: ["Gitanga", "Ruhunde", "Gakenke", "Gikokwe", "Mataba", "Gatonde", "Mugunga", "Murandi", "Remera", "Nyirangarama", "Bushoki", "Kirambo", "Rusarabuye", "Harvest", "Church"],
      rw: ["Murambi", "Gisenyi", "Karambi", "Murundi", "Rwinkwavu", "Mining", "Karembo", "Kayonza", "Nyamiram", "Fumbwe", "Ngarama"],
    },
    2: {
      k: ["Muko", "Rukoma Remera", "Nyamata", "Shangash", "Kajyanjya", "NgerukaTwimpala", "Rongi Ruhango", "Rushaki Rushaki", "Mayange"],
      b: ["Nyanza", "Camp", "Gasaka", "Mututu", "TTC Save"],
      ko: ["Rutsiro", "Kivumu", "Murunda", "Mburamazi", "Mushubati", "Kamembe", "Cite", "Camp", "KamembCit"],
      ru: ["Nyanga Kinon", "Kinkware", "Camp I", "Kidaho Camp", "Camp II", "Gifur", "Minin", "ELGatovu", "ES Ki"],
      rw: ["Bushara", "Rwempasha", "Munini", "Rugarama", "Nyagatare", "Murama", "Rukira", "Rukomo", "Shimwa Polo"],
    },
    3: {
      k: ["Kisaro Kisaro", "Cyumba Cyumba", "Nyarugenge", "Rweru Nkanga", "Muhondo", "Jarama Jarama", "Cyeza Rutobwe", "Musambira", "E.S Kinazi TSS", "Nyakaliro", "Bihembe", "Nyarusange", "Karama Norvege"],
      b: ["Musebeya", "Bira", "Mushubi", "Gikonko", "Musha", "ADEPR", "Cyarwa"],
      ko: ["Bushenge", "Mwezi", "Gihundwe", "Nzahaha", "Rwimbogo", "Bugarama", "Cite", "Mibirizi", "Nyakarenz", "Muganza", "SDA Syiki"],
      ru: ["Mubug", "Muz", "Byang", "Buso", "Hospital", "APEFO", "GS Sh", "Nemba", "TSS", "APARP", "Rwank", "ETKar", "Kir", "Rusar"],
      rw: ["Rwimbogo", "Rwamagana", "Rubona", "TSS", "KibungRubon", "Ruramira", "Mining", "MushMining", "Paroisse"],
    },
    4: {
      k: ["Nyamiyaga", "Kidahwe", "Kigese", "Ruhuha", "E.S Bulinga", "Rulindo", "Mushongi", "TVET", "Mulindi", "Karenge", "Mwendo", "Mutara", "Kayenzi Kayenzi", "Kinihira TVET", "Kagamba", "Masaka"],
      b: ["Lycee", "Nyanza", "Kamwambi", "Kizibere", "Murama", "Kavumu", "TSS", "Ruhango", "Adventist"],
      ko: ["Ndaro", "Biguhu", "Rubenge", "Kibir", "Mubuga", "Congo-N", "SDA Kaye"],
      ru: ["Rusumo", "Butaro", "Gasiza", "Cyuve", "ETAG", "Nyamugari", "Nemba", "Kinyababa", "Kabatwa", "ESc", "Gisenyi", "Rutovu", "Kanzenze", "Rushara", "ETEFOP"],
      rw: ["Rwimiyaga", "Shonga", "Cyabayaga", "Mimuli", "Gikagati", "Runyinya", "Gishororo", "Matimba", "Karambi", "Nyagatare", "Nyagatare SS"],
    },
    5: {
      k: ["Bukure", "Bitsibo", "APEKI", "Tumba", "Ngeruka", "Murama", "Rukumberi", "Cat"],
      b: ["Mamba", "Uwinkomo", "Kigembe", "GS Kigoma", "Ruhango"],
      ko: ["Kibogor", "Hosp", "Bigugu", "Gatare", "Ruhango"],
      ru: ["Kinanira", "Kabaya", "Kamubuga Chri"],
      rw: ["Gahini", "Muhazi", "Gishari", "ASPEJ"],
    },
    6: {
      k: [],
      b: [],
      ko: ["TES"],
      ru: [],
      rw: ["TES"],
    },
  },
  OCTOBER: {
    1: {
      k: ["TTC Muhanga", "St Etienne", "Shyogwe", "Mugambazi", "Bwisige", "Nyabushingitwa", "Muhura", "E.S Rutobwe", "Muhondo Huro", "Cyeza Cyeza"],
      b: ["Kiyonza", "GS Sekera", "Nyamagabe", "TSS", "ETI Save"],
      ko: ["Kibirizi", "GS Mugonero", "TSS", "St Martin", "Hanika", "Mubuga"],
      ru: ["Bisate Kini", "Gifurw", "Rugengabar", "Busasamana", "Nyarutovu", "Kivuruga"],
      rw: ["Rurama", "Gitwe", "Protestant", "Mugesera"],
    },
    2: {
      k: ["Kamabuye", "Kepler", "TTVET", "Mukarange", "Nyamata TSS", "Byumba", "Runda Gihara", "G.S Karenge", "Tumba Tumba", "Shyorongi", "Rwahi", "Nyankenke", "Yaramba", "Kiyumba", "Remera", "Remer Rukom", "D.d.Dieu", "Paroisse", "Gahanga"],
      b: ["ESc", "Nyamagabe", "ES Kigom", "Muhambara", "ES Higiro", "ES Sumba", "ESPANY", "Nyanza", "GSOB"],
      ko: ["IPK", "Nyarubuye", "Munigi", "Umucyo", "Karengera", "ESAPAN", "Esperence", "TSS"],
      ru: ["Rusumo", "Camp I", "Murandi", "Remera", "Bihe Bugesh", "Camp II", "Mutobo", "Busogo", "GS Kanama", "Kanyirareb", "Gahung", "Kampanga", "Kinigi", "TSS", "Gahunga", "GSNDA", "Nyundo"],
      rw: ["Nyange", "Rusumo", "Nyakarambi", "St Vincent de", "Paul", "Kabarondo", "St Aloys", "Gakoni", "Adventist", "Gishanda", "Agahozo"],
    },
    3: {
      k: ["Rugendabari", "Kanyana", "Rongi Mbuye", "ACEJ Karama", "Ruhunde", "Miyove Miyove", "Mukarange", "Mukarang", "Butamwa", "College", "Rutunga", "Sake Sake", "Mugina St", "Ignace", "E.S Muhororo", "TC de la Salle", "Byumba"],
      b: ["CXR", "Nyarugu", "CFPRO", "Ruhang", "Butansi", "ES Save", "GS Nyumba", "Vunga", "Kamiraba", "ADEPR T"],
      ko: ["Karengera", "Gitwa", "Mburabutu", "Gishyita Sh", "Mbuga", "Rwinyoni", "Cyimbiri", "GS Bumba", "TSS", "Tyazo TSS"],
      ru: ["Bisate", "Kinigi", "Byangabo", "Busogo", "Nyamuga", "Nemba", "Kanyira", "Gahung", "Gatovu", "Kinto", "Mucac", "Rugenga", "ESTB Bu", "ES Kago", "Kamina", "Busengo"],
      rw: ["Kiziguro", "Kansana", "Zaza", "Ngoma", "Kigarama", "Rwamagana", "Kabare", "TSS", "Mutenderi", "Rushenyi", "Gahini"],
    },
    4: {
      k: ["Ruvune Kabare", "Musenyi-Gicaca", "E.S Kinazi TSS", "UNILAK", "Gishaka Gishaka", "Kinazi Kinazi", "Ruvune Rebero", "Rilima", "Nyabagendwa", "JAM Shyogwe", "ETEKA Kabgayi", "Mugina", "TSS", "Healing C", "Remera", "EPR Remera"],
      b: ["Kaduha", "Kad", "ES Nko", "TTC Mbuga"],
      ko: ["Rutsiro", "Kigeyo", "Buhindu", "Vumbi", "Bumba TSS", "CP Ruts", "Mushuba", "ES Murunda", "Ste Mar", "Kibuye"],
      ru: ["Nyang", "Kinon", "Runab", "Butar", "Kabatwa", "Gaton", "APARPE TSS", "Musanze", "Busen", "Buse", "Base"],
      rw: ["Rusum", "Nyakaramb", "KATS", "Paysanat G", "SOPEM", "Gihorwe", "Garden TSS", "GS Remera", "Rusumo", "Rwanteru", "TSS", "GS Gahara", "GS Mugogo", "ESc", "Lycee zaza", "Camp"],
    },
    5: {
      k: ["Mpanda TSS", "Muhanga TC", "Nyamirambo", "Miduha", "APAPEDUC", "Bungwe", "G.S Kabuga", "Ngororero", "Rusus", "Nyabikenke TSS", "Ruhunde", "TVET", "Nyakabanda", "Kamonyi"],
      b: ["Cyabaka", "Busasam", "Gishari", "Gitisi TSS", "Buhimba", "EAV Kabutare", "Indangaburezi", "APARUDE"],
      ko: ["Gasenyi", "Cyinama", "Bisesero", "APAKAPE", "Bwishyu", "Nyabidahe", "GS Kavum"],
      ru: ["Reg", "Bigog", "Rusha", "Nemba", "ESIR TSS", "Kor", "URCAVM", "RTC Rubavu", "GS Hindiro", "College GFB"],
      rw: ["TTC", "Kabarore", "Gahima", "TTC Bicumbi", "Rubona I&II", "Vocational"],
    },
  },
  NOVEMBER: {
    1: {
      k: ["Regina Pacis"],
      b: ["ADEPR", "Matyazo"],
      ko: [],
      ru: [],
      rw: ["Center For", "Champ"],
    },
    2: {
      k: ["Rukozo Rukozo", "Mugina Kabuga", "Mageragere", "Mines", "Kageyo TSS", "Rukoma", "Mwirute", "Mukarange", "Inyange", "Ngororero", "Kinazi Rutabo", "Gatsibo", "Nyagahanga", "EFA", "TSS", "Muyongwe", "Cyeza Kivumu"],
      b: ["Viro", "Rurangazi", "Kareba", "Ntongwe TSS", "Rwintama", "Mugombwa", "Kibyagira"],
      ko: ["St Paul Tya", "Es Tyazo", "GS St Josep", "Nyamasheke", "ES Urumuri", "GS Muhororo", "EAV Kivumu", "GSFAK"],
      ru: ["Kabumba", "Bugeshi", "Goico Camp I", "Goico Camp", "Rugarama", "St Martin", "Mahoko", "Camp I", "Buringo", "Camp II", "Ecole d'Art", "Nyundo", "GS Rambura", "Filles", "Busengo"],
      rw: ["Ngoma", "Nyamugal", "Gikaya", "Mukarange", "Katabagemu", "TSS", "Sakara", "UR Nyagatare", "Gatunda", "Karama", "Mutumba"],
    },
    3: {
      k: ["Bugesera", "Mwendo", "Rusiga Rusiga", "Kageyo", "Muhondo", "Nyamata", "Nzige Nzige", "Ngeruka", "Twimpala", "BumbogoTVET", "Gatumba", "Rusumo", "Grand Sem", "Kabgayi", "E.S Nyakabanda", "APAPEC", "Murambi", "Giti Kaba", "Runzenz"],
      b: ["Ruhe", "GS Cyarwa", "GS Mwurire", "Kabuga", "GS Kinazi", "ES Ruhango", "GS Gitisi", "GS Gatagar", "GS Butare", "Cath", "ENDP", "Karuband"],
      ko: ["Adv"],
      ru: ["Giheke", "Mizero TSS", "GS Muganza", "TSS", "Giheke TSS", "GS Gihundwe", "Mibirizi TSS", "EAV Ntendezi"],
      rw: ["Nganda", "Shingiro", "Mpanga", "Nyabubare", "Rwaza Rwaza", "CF Sina", "Nyabitare", "Gerard", "Ryabizige", "Cyanzarwe", "Kareba Jenda", "Gitare", "Kagogo", "Mushikiri", "GS Kabatwa", "Musanze", "CBS Kinigi", "Janja Janja"],
    },
    4: {
      k: ["Kisaro Kisaro", "Cyumba", "Nyarugenge", "Mount Kigali", "Karama", "Kabacuzi", "Buramba", "Shangasha", "Kajyanjyari", "Bumbogo", "Mwogo Mwogo", "Muyumbu", "Murama", "Nyarusange", "Norvege"],
      b: ["Migina", "ES Nyanza", "Gd Sem", "Nyakiban", "Kinwete", "GS Muyange", "CS Kibirizi", "GS Cyahinda", "Rugogwe"],
      ko: ["EPR Mataba"],
      ru: ["Karambi", "Nyamasheke", "St Joseph", "Birambo", "GS Kirinda", "Cya", "Kirinda", "Muh", "Marie", "Reine Mur", "Nil", "Kiv", "ES Rubengera", "Rus", "Har", "Chu"],
      rw: ["TSS Musaza", "Hindiro TSS", "Hindiro", "Buhenger", "Murambi", "Busasamn", "Kayonza", "TSS", "Nyamirama", "Fawe", "Paroisse", "Rwamagna"],
    },
    5: {
      k: ["Ngamba", "Musenyi", "Sancta Maria", "Kamonyi", "Rweru", "Nyarurenzi", "Rukoma", "Remera", "Muyumbu", "Gashora", "Kazirabonde", "Mugina Mugina", "Car Free Zone", "Gasange", "Mutete Gaseke", "Paroisse", "Kicukiro", "Nyamirambo"],
      b: ["Kaganza", "Cyanika TSS", "Mushubi", "GS Ruyenzi", "Rebero", "Ntongwe", "GS Kigeme", "Karama", "TTC Save"],
      ko: ["Mac", "Rugabano", "Ruga", "Rug", "Con", "Bir"],
      ru: ["Tea", "Ruh", "INE", "Ruhe", "UGH", "MIP", "Kam", "Ryan", "Gisiza", "Nil", "Kibi"],
      rw: ["INES", "Rugoma", "APENA", "Musanze", "E Musha", "Rwamagana", "APPAGIE", "Murambi", "Gisenyi", "Nyabisindu", "TSS", "EAR Gahini"],
    },
    6: {
      k: ["Nyakaliro"],
      b: ["ES Kigembe", "CS Kigoma"],
      ko: ["Sit", "SIT"],
      ru: ["Buge"],
      rw: [],
    },
  },
  DECEMBER: {
    1: {
      k: ["Bushoki", "Gasiza", "Nyamabuye", "Rukumberi", "Buyoga", "Busoro", "Ntongw", "Nyakabung", "Mayange", "MinazMunya"],
      b: ["UR Huye", "Camp", "UR HuyCamp", "Buhanda", "IPRC", "Huye", "GS Ntongwe", "Nyamagabe", "TSS", "Kitabi"],
      ko: ["Tyazo", "Kibogora", "MugonerHosp", "Biguhu", "Kayove", "Syiki", "Kagano", "Nyamasheke"],
      ru: ["Gatonde", "Mugunga", "Shyira DH", "MubugaMuzo", "Gasiza", "Rambura", "UR CAVM", "Gasiza Cyuve", "Gakenke", "Murambo", "Janja"],
      rw: ["Mulindi", "Mimuli", "Nyagashanga", "Musheli", "Kirwa", "Muhazi", "Murambi", "Ngarama", "Kirehe", "Kigarama"],
    },
    2: {
      k: ["Mukama", "Gihengeli", "Kivuye", "Byimana", "Ruli Ruli", "Muyumbu", "Murehe", "Kaniga", "Mulindi", "Rushaki", "Masaka", "Rusheshe"],
      b: ["Imberabyom", "Camp", "Ruramba", "Rwamiko", "Mironzi", "Kimirama", "Rwanza", "Musebeya", "Birambo"],
      ko: ["Bushenge", "Mwezi", "Nyakabuye", "Gihundwe", "Hospital", "Nzahaha", "Rwimbogo", "Bugarama Cite", "Mibirizi", "Nyakarenzo", "Bugarama", "Muganza"],
      ru: ["Rusumo", "Butaro", "Gihorwe", "Kabatwa", "Kirambo", "Rusarabuye", "Kamubuga", "Nyirangarama", "Bushoki", "GisenyiTo", "Base Camp", "GisenyTow", "Base Camp II"],
      rw: ["Mutenderi", "Mukarange", "Cath", "Kiyazi", "Gahini", "Gahengeri", "Mining", "Shimwa palo", "Gatore", "Kibungo", "L2TH"],
    },
    3: {
      k: ["Muko", "Bungwe", "Rutare", "Kibangu", "Tumba", "NyakalirBihe", "Nyamiyaga", "Kagamba", "Kinihira"],
      b: ["Karambi", "Ruhango", "Busoro"],
      ko: ["Murunda", "Hosp", "KibogorHos", "Kirinda", "Hospital", "Musasa", "Gisiza", "Gakeri", "Kamembe Ci", "Camp", "Kamembe Cite"],
      ru: ["Kinogo", "Busasaman", "Gahunga", "Masha", "Cyabingo", "Vunga", "Shyira", "Murandi", "Remera", "Gifurwe", "Rugengaba", "Kabere Mu", "Gitanga", "Ruhunde", "Kabaya Camp", "Kamina", "Busengo", "Kabaya Ca"],
      rw: ["Rwimiyaga", "Mpanga", "Kiyombe", "Gasetsa", "Mugera", "Kayonz", "Nyamiram", "Fumbwe", "Paroisse", "Kibungo"],
    },
    4: {
      k: ["Rushashi", "Kageyo", "Bukure", "Bitsibo", "NgomRemer", "Muhondo", "Muh", "AEBR", "Kacyiru", "Buyoga", "Gitumba", "Masaka", "Nyinawimana"],
      b: ["Gafumba"],
      ko: ["Kibuye CAMP", "Rubenge", "Kibir", "Boneza", "Kinunu", "EPR Git"],
      ru: ["Jenda", "Mubuga", "Nyamug", "Nemb", "Mucac", "Rugeng", "Rem", "Muran", "Rwanke", "Mukami"],
      rw: ["Bushara", "Kinteko", "Rwempasha", "Muzo", "Nyinya", "Karembo", "Rukomo", "Rwimbogo"],
    },
    5: {
      k: ["JurKabukub", "Mushishiro", "Ruli", "Gitega", "Shyara", "Gihinga", "Kaniga", "Mulindi"],
      b: [],
      ko: ["Gihombo", "Kibing", "Nyamash", "Mushuba", "Murund", "Mburama", "Mubuga"],
      ru: ["Nyang", "Kinon", "Rusa", "Kivu", "Gaken", "Kivur", "Kor", "Bigog", "Nyamug", "Nemb"],
      rw: ["Kiramuruzi", "Nyagatare", "Nyinya", "Cyarubare", "Murama", "Rukira"],
    },
  },
};


const MONTHS_ORDER = ["JANUARY","FEBRUARY","MARCH","APRIL","MAY","JUNE","JULY","AUGUST","SEPTEMBER","OCTOBER","NOVEMBER","DECEMBER"];

// Pages 0–5 are fixed sections; each month section takes 4 landscape pages.
// These are the ONLY things that need to change if the document structure changes.
const _FIXED_PAGES   = 6;  // cover(0) contents(1) foreword(2) toc(3) divider(4) summary(5)
const _PAGES_PER_MONTH = 4;
const _lastMonthStart = _FIXED_PAGES + (MONTHS_ORDER.length - 1) * _PAGES_PER_MONTH;
const PDF_TOTAL_PAGES = _lastMonthStart + (_PAGES_PER_MONTH - 1); // 53: 12 months only

const _curY = new Date().getFullYear();
const YEARS = Array.from({ length: 6 }, (_, i) => _curY + 2 - i).map(y => ({ label: String(y), value: y }));

const fmt = n => (n != null && n !== "") ? Number(n).toLocaleString() : "";
const cleanSite = name => (name || "").split("=")[0].trim();

// Match a center name to one of the 5 known short keys by keyword
const CENTER_KEY_MAP = [
  { key: "k",  keywords: ["kigali"] },
  { key: "b",  keywords: ["butare", "huye"] },
  { key: "ko", keywords: ["karongi"] },
  { key: "ru", keywords: ["ruhengeri", "musanze"] },
  { key: "rw", keywords: ["rwamagana"] },
];

const nameToKey = (name = "") => {
  const lower = name.toLowerCase();
  for (const { key, keywords } of CENTER_KEY_MAP) {
    if (keywords.some(kw => lower.includes(kw))) return key;
  }
  return null;
};

// ─── Shared cell helpers ──────────────────────────────────────────────────────
const BD = `1px solid ${C.border}`;
const td  = (extra = {}) => ({ border: BD, padding: "2px 4px", fontSize: 8, verticalAlign: "middle", ...extra });
const th  = (bg, color = C.white, extra = {}) => ({ ...td(), background: bg, color, fontWeight: "bold", textAlign: "center", padding: "2px 3px", ...extra });

// ─── Common footer ────────────────────────────────────────────────────────────
const PageFooter = ({ pageNum, total = PDF_TOTAL_PAGES }) => (
  <div className="print-only" style={{ borderTop: `1px solid #999`, marginTop: 6, paddingTop: 3, textAlign: "center", fontSize: 8, color: "#444" }}>
    Page {pageNum} of {total}
  </div>
);

// ─── Blue top strip shared by most pages ─────────────────────────────────────
const BlueHeader = ({ year }) => (
  <div style={{
    background: C.headerBar, color: C.white, textAlign: "center",
    fontWeight: "bold", fontSize: 9, padding: "3px 0", letterSpacing: 1,
    marginBottom: 8,
  }}>
    BTD ACTIVITY BOOK - {year}
  </div>
);

const PageBreak = () => <div className="page-break" style={{ pageBreakAfter: "always", breakAfter: "page", height: 0, display: "block" }} />;

// ─── FRONT page wrapper (all pages are landscape) ────────────────────────────
const PortraitPage = ({ children, style = {} }) => (
  <div className="landscape-page" style={{
    fontFamily: "Arial, sans-serif", background: C.white,
    padding: "8mm 12mm", boxSizing: "border-box",
    display: "flex", flexDirection: "column",
    ...style,
  }}>
    {children}
  </div>
);

// ─── LANDSCAPE page wrapper ───────────────────────────────────────────────────
const LandscapePage = ({ children, style = {} }) => (
  <div className="landscape-page" style={{
    fontFamily: "Arial, sans-serif", background: C.white,
    padding: "4px 2px", boxSizing: "border-box",
    ...style,
  }}>
    {children}
  </div>
);

// ══════════════════════════════════════════════════════════════════════════════
// PAGE 0 — COVER PAGE
// ══════════════════════════════════════════════════════════════════════════════
const CoverPage = ({ year, cfg }) => {
  const line1     = cfg?.line1     ?? "RWANDA BIOMEDICAL CENTRE";
  const line2     = cfg?.line2     ?? "BIOMEDICAL SERVICES DEPARTMENT";
  const line3     = cfg?.line3     ?? "BLOOD TRANSFUSION DIVISION";
  const bookTitle = (cfg?.bookTitle ?? "Activity\nBook").replace(/\\n/g, "\n");
  const logoLeft  = cfg?.logoLeft  || rbcLogo;
  const logoRight = cfg?.logoRight || btdLogo;
  const coverImg  = cfg?.coverImg  || bloodImg;
  return (
  <PortraitPage style={{ padding: 0 }}>
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "24px 24px 20px", minHeight: 90,
    }}>
      <img src={logoLeft}  alt="RBC" style={{ height: 62 }} />
      <img src={logoRight} alt="BTD" style={{ height: 72 }} />
    </div>
    <div style={{ background: C.headerBar, flex: "0 0 auto" }}>
      <div style={{ padding: "22px 24px 0" }}>
        <div style={{ color: C.white, textAlign: "center", fontWeight: "bold", fontSize: 15, marginBottom: 5 }}>{line1}</div>
        <div style={{ color: C.white, textAlign: "center", fontSize: 11, marginBottom: 5 }}>{line2}</div>
        <div style={{ color: C.white, textAlign: "center", fontWeight: "bold", fontSize: 11, marginBottom: 0 }}>{line3}</div>
      </div>
      <div style={{ marginTop: 18, display: "flex", alignItems: "center", justifyContent: "center", padding: "12px 20px" }}>
        <div style={{ color: "#FFD700", fontWeight: "bold", fontSize: 32, minWidth: 80, textAlign: "center", lineHeight: 1 }}>{year}</div>
        <div style={{ width: 2, background: "rgba(255,255,255,0.6)", alignSelf: "stretch", margin: "2px 18px" }} />
        <div style={{ color: C.white, fontWeight: "bold", fontSize: 30, lineHeight: 1.15, whiteSpace: "pre-line" }}>{bookTitle}</div>
      </div>
    </div>
    <div style={{ flex: 1, overflow: "hidden", minHeight: 120 }}>
      <img src={coverImg} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
    </div>
    <PageFooter pageNum={0} />
  </PortraitPage>
  );
};

// ══════════════════════════════════════════════════════════════════════════════
// PAGE 1 — CONTENTS
// ══════════════════════════════════════════════════════════════════════════════
const ContentsPage = ({ year, cfg }) => {
  const sections = cfg?.sections ?? [
    { letter: "A", title: "ANNUAL BLOOD COLLECTION PLAN", subtitle: `Blood donation activity targets for all RCBTs, RMTH BB & RNP — ${year}` },
    { letter: "B", title: "CORNEA RETRIEVAL PLAN",        subtitle: `Cornea retrieval and supply targets — ${year}` },
    { letter: "C", title: "HEMOVIGILANCE & CORNEA-VIGILANCE ACTIVITY PLAN", subtitle: `Safety monitoring and hemovigilance activity plan — ${year}` },
    { letter: "D", title: "FIELD ACTIVITY PLAN",          subtitle: `Outreach and operational field activity plan — ${year}` },
  ];
  const copyrightText = cfg?.copyrightText ??
    "This plan is the Blood Transfusion Division property, under the Biomedical Services Department of the Rwanda Biomedical Centre.";
  return (
    <PortraitPage>
      <BlueHeader year={year} />

      {/* Page title */}
      <div style={{ textAlign: "center", marginBottom: 28 }}>
        <div style={{ fontSize: 13, fontWeight: "bold", letterSpacing: "0.06em", color: C.black }}>CONTENTS</div>
        <div style={{ width: 40, height: 3, background: C.headerBar, margin: "8px auto 0", borderRadius: 2 }} />
      </div>

      {/* Section cards */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 16, paddingBottom: 16 }}>
        {sections.map((sec, i) => (
          <div key={i} style={{ display: "flex", alignItems: "stretch", border: `1px solid #ddd`, borderRadius: 4, overflow: "hidden" }}>
            {/* Letter badge */}
            <div style={{
              width: 44, flexShrink: 0,
              background: i % 2 === 0 ? C.headerBar : C.centerGreen,
              display: "flex", alignItems: "center", justifyContent: "center",
              color: C.white, fontWeight: "bold", fontSize: 18, letterSpacing: "0.02em",
            }}>
              {sec.letter}
            </div>
            {/* Text */}
            <div style={{ padding: "10px 14px" }}>
              <div style={{ fontWeight: "bold", fontSize: 10, color: C.black, marginBottom: 3 }}>{sec.title}</div>
              <div style={{ fontSize: 8, color: "#555", lineHeight: 1.4 }}>{sec.subtitle}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Copyright */}
      <div style={{ borderTop: "1px solid #ddd", paddingTop: 10, marginBottom: 6, textAlign: "center" }}>
        <div style={{ fontWeight: "bold", fontSize: 9, marginBottom: 4, color: C.black }}>Copyright © {year}</div>
        <div style={{ fontSize: 8, color: "#555", maxWidth: 320, margin: "0 auto", lineHeight: 1.5 }}>
          {copyrightText}
        </div>
      </div>
      <PageFooter pageNum={1} />
    </PortraitPage>
  );
};

// ══════════════════════════════════════════════════════════════════════════════
// PAGE 2 — FOREWORD
// ══════════════════════════════════════════════════════════════════════════════
const ForewordPage = ({ year, cfg }) => {
  const paragraphs    = cfg?.paragraphs   ?? [
    "Since 2016, the Rwanda Biomedical Centre (RBC), through its Blood Transfusion Division (BTD), has upheld a tradition of strategic foresight by preparing the Annual Blood Collection Plan (ABCP) before the start of each year. This plan has been instrumental in ensuring a reliable supply of safe blood and blood products, while also strengthening donor recruitment and retention nationwide. By anchoring operations in careful planning, the Division has safeguarded both efficiency and public health.",
    "In 2025, BTD management has taken a significant step forward by consolidating all major operational frameworks into a single, comprehensive document: the BTD ANNUAL ACTIVITY BOOK. This innovation integrates the Blood Collection Plan, the Hemovigilance Activity Plan, the Bio-Banking Unit Activity Plan, and the Field Activity Plan. Together, these plans provide a unified roadmap that enhances coordination, accountability, and responsiveness across the Division's diverse activities.",
    "The Annual Blood Collection Plan remains the cornerstone, setting evidence-based targets for each Regional Centre for Blood Transfusion (RCBT) according to projected demand from Treatment Health Facilities. Complementary plans reinforce this foundation: The Annual Blood Collection Plan emphasizes on blood donation activities, the Hemovigilance Plan ensures safety and monitoring, the Bio-Banking Plan advances cornea retrieval and supply for patients in need and the Field Activity Plan strengthens outreach and operational delivery. Each plan plays a distinct role, yet all converge toward the shared mission of saving lives and sustaining Rwanda's healthcare system.",
    "The BTD Annual Activity Book is therefore more than a compilation of tasks; it is a strategic instrument of preparedness and excellence. By uniting diverse activities under one vision, it reflects Rwanda's commitment to proactive planning, innovation, and resilience in healthcare.",
  ];
  const approvedDate  = cfg?.approvedDate ?? "............/............/2025";
  const signatories   = cfg?.signatories  ?? [
    { name: "Prof. MUVUNYI Mambo Claude", role: "Director General" },
    { name: "Dr Isabelle MUKAGATARE",     role: "Head of Biomedical Services\nDepartment" },
    { name: "Dr Thomas MUYOMBO",          role: "Blood Transfusion\nDivision Manager" },
  ];
  return (
  <PortraitPage>
    <BlueHeader year={year} />
    <div style={{ fontWeight: "bold", fontSize: 11, marginBottom: 12, color: C.black }}>FOREWORD</div>
    <div style={{ fontSize: 9, lineHeight: 1.6, textAlign: "justify", color: C.black }}>
      {paragraphs.map((p, i) => (
        <p key={i} style={{ marginBottom: i < paragraphs.length - 1 ? 8 : 0 }}>{p}</p>
      ))}
      <p style={{ marginBottom: 32, marginTop: 8 }}>Approved on {approvedDate} by:</p>
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 24 }}>
      {signatories.map((sig, i) => (
        <div key={i} style={{ textAlign: "left", width: "30%", fontSize: 8, color: C.black }}>
          {sig.signatureUrl && (
            <img
              src={sig.signatureUrl}
              alt="signature"
              style={{ height: 36, maxWidth: "100%", objectFit: "contain", display: "block", marginBottom: 2 }}
            />
          )}
          <div style={{ marginBottom: 6 }}>...........................</div>
          <div style={{ fontWeight: "bold" }}>{sig.name}</div>
          <div style={{ whiteSpace: "pre-line" }}>{(sig.role || "").replace(/\\n/g, "\n")}</div>
        </div>
      ))}
    </div>
    <PageFooter pageNum={2} />
  </PortraitPage>
);
};

// ══════════════════════════════════════════════════════════════════════════════
// PAGE 3 — TABLE OF CONTENT
// ══════════════════════════════════════════════════════════════════════════════
const TOCPage = ({ year, cfg }) => {
  const entries = cfg?.entries ?? [
    { title: "FOREWORD", page: 2 },
    { title: "TABLE OF CONTENT", page: 3 },
    { title: `A. ANNUAL BLOOD COLLECTION PLAN ${year}`, page: 4 },
    { title: `B. CORNEA RETRIEVAL PLAN ${year}`, page: 54 },
    { title: `C. HEMOVIGILANCE AND CORNIAL-VIGILANCE ACTIVITY PLAN ${year}`, page: 58 },
    { title: `D. FIELD ACTIVITY PLAN ${year}`, page: 101 },
    { title: "CONTRIBUTORS", page: 107 },
  ];
  return (
    <PortraitPage>
      <BlueHeader year={year} />
      <div style={{ fontWeight: "bold", fontSize: 11, marginBottom: 16 }}>TABLE OF CONTENT</div>
      <div>
        {entries.map((e, i) => (
          <div key={i} style={{ display: "flex", justifyContent: "space-between", fontSize: 9, marginBottom: 8, alignItems: "flex-end" }}>
            <div>{e.title}</div>
            <div style={{ flex: 1, borderBottom: "1px dotted #999", margin: "0 4px 2px" }} />
            <div style={{ fontWeight: "bold", minWidth: 20, textAlign: "right" }}>{e.page}</div>
          </div>
        ))}
      </div>
      <PageFooter pageNum={3} />
    </PortraitPage>
  );
};

// ══════════════════════════════════════════════════════════════════════════════
// PAGE 4 — SECTION DIVIDER
// ══════════════════════════════════════════════════════════════════════════════
const SectionDividerPage = ({ year, cfg }) => (
  <PortraitPage>
    <BlueHeader year={year} />
    <div style={{
      flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: 18, fontWeight: "bold", textAlign: "center", color: C.black,
    }}>
      {cfg?.sectionTitle ?? `A. ANNUAL BLOOD COLLECTION PLAN ${year}`}
    </div>
    <PageFooter pageNum={4} />
  </PortraitPage>
);

// ══════════════════════════════════════════════════════════════════════════════
// PAGE 5 — SUMMARY TABLE
// ══════════════════════════════════════════════════════════════════════════════
const SummaryPage = ({ year, cfg }) => {
  const summaryRows  = cfg?.rows  ?? SUMMARY;
  const summaryTotal = cfg?.total ?? SUMMARY_TOTAL;
  const centerKeys   = ["kigali","butare","karongi","ruhengeri","rwamagana"];
  const centerLabels = ["KIGALI","BUTARE","KARONGI","RUHENGERI","RWAMAGANA"];

  return (
    <LandscapePage style={{ padding: "8px 10px" }}>
      <BlueHeader year={year} />
      <div style={{ fontWeight: "bold", fontSize: 10, textAlign: "center", marginBottom: 8 }}>
        SUMMARY OF THE ANNUAL BLOOD COLLECTION PLAN {year} - ALL RCBTs, RMTH &amp; RNP
      </div>
      <div style={{ border: `2px solid ${C.totalWeek}`, display: "inline-block", width: "100%" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th style={th(C.centerGreen, C.white, { fontSize: 8, width: 52 })}>RCBTs</th>
              {centerLabels.map(c => (
                <th key={c} style={th(C.centerGreen, C.white, { fontSize: 7 })} colSpan={2}>{c}</th>
              ))}
              <th style={th(C.centerGreen, C.white, { fontSize: 7, fontWeight: "bold" })} colSpan={2}>TOTAL RCBTs</th>
              <th style={th(C.centerGreen, C.white, { fontSize: 7 })} colSpan={2}>RMTH BB</th>
              <th style={th(C.centerGreen, C.white, { fontSize: 7 })} colSpan={2}>RNP</th>
              <th style={th(C.totalColHdr, C.white, { fontSize: 7 })} colSpan={2}>TOTAL RCBTs, RMTH BB, RNP</th>
            </tr>
            <tr>
              <th style={th(C.weekSection, C.black, { fontSize: 7 })}>MONTHS</th>
              {[...centerLabels,"TOTAL RCBTs","RMTH BB","RNP"].map((_, i) => (
                <React.Fragment key={i}>
                  <th style={th(C.weekSection, C.black, { fontSize: 6 })}>Units</th>
                  <th style={th(C.weekSection, C.black, { fontSize: 6 })}>Sessions</th>
                </React.Fragment>
              ))}
              <th style={th(C.totalColHdr, C.white, { fontSize: 6 })}>UNITS</th>
              <th style={th(C.totalColHdr, C.white, { fontSize: 6 })}>SESSIONS</th>
            </tr>
          </thead>
          <tbody>
            {summaryRows.map((row, i) => (
              <tr key={row.month} style={{ background: i % 2 === 0 ? C.white : C.altRow }}>
                <td style={td({ fontWeight: "bold", fontSize: 7 })}>{row.month}</td>
                {centerKeys.map(k => (
                  <React.Fragment key={k}>
                    <td style={td({ textAlign: "center", fontSize: 7 })}>{fmt(row[k][1])}</td>
                    <td style={td({ textAlign: "center", fontSize: 7 })}>{row[k][0]}</td>
                  </React.Fragment>
                ))}
                <td style={td({ textAlign: "center", fontWeight: "bold", fontSize: 7 })}>{fmt(row.rcbtTotal[1])}</td>
                <td style={td({ textAlign: "center", fontWeight: "bold", fontSize: 7 })}>{row.rcbtTotal[0]}</td>
                <td style={td({ textAlign: "center", fontSize: 7 })}>{fmt(row.rmth[1])}</td>
                <td style={td({ textAlign: "center", fontSize: 7 })}>{row.rmth[0]}</td>
                <td style={td({ textAlign: "center", fontSize: 7 })}>{fmt(row.rnp[1])}</td>
                <td style={td({ textAlign: "center", fontSize: 7 })}>{row.rnp[0]}</td>
                <td style={{ ...td(), textAlign: "center", fontWeight: "bold", background: C.totalColAlt, fontSize: 7 }}>{fmt(row.grand[1])}</td>
                <td style={{ ...td(), textAlign: "center", fontWeight: "bold", background: C.totalColAlt, fontSize: 7 }}>{row.grand[0]}</td>
              </tr>
            ))}
            <tr style={{ background: C.summaryTotal, fontWeight: "bold" }}>
              <td style={td({ fontWeight: "bold", fontSize: 7 })}>TOTAL {year}</td>
              {centerKeys.map(k => (
                <React.Fragment key={k}>
                  <td style={td({ textAlign: "center", fontSize: 7 })}>{fmt(summaryTotal[k][1])}</td>
                  <td style={td({ textAlign: "center", fontSize: 7 })}>{summaryTotal[k][0]}</td>
                </React.Fragment>
              ))}
              <td style={td({ textAlign: "center", fontWeight: "bold", fontSize: 7 })}>{fmt(summaryTotal.rcbtTotal[1])}</td>
              <td style={td({ textAlign: "center", fontWeight: "bold", fontSize: 7 })}>{summaryTotal.rcbtTotal[0]}</td>
              <td style={td({ textAlign: "center", fontSize: 7 })}>{fmt(summaryTotal.rmth[1])}</td>
              <td style={td({ textAlign: "center", fontSize: 7 })}>{summaryTotal.rmth[0]}</td>
              <td style={td({ textAlign: "center", fontSize: 7 })}>{fmt(summaryTotal.rnp[1])}</td>
              <td style={td({ textAlign: "center", fontSize: 7 })}>{summaryTotal.rnp[0]}</td>
              <td style={{ ...td(), textAlign: "center", fontWeight: "bold", fontSize: 7 }}>{fmt(summaryTotal.grand[1])}</td>
              <td style={{ ...td(), textAlign: "center", fontWeight: "bold", fontSize: 7 }}>{summaryTotal.grand[0]}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <PageFooter pageNum={5} />
    </LandscapePage>
  );
};

// ══════════════════════════════════════════════════════════════════════════════
// PAGES 6+ — MONTHLY DETAIL PAGES (landscape)
// ══════════════════════════════════════════════════════════════════════════════
const ordinal = (n) => {
  const s = ['th','st','nd','rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const getWeekDaysList = (monthName, weekNum, year = 2026) => {
  const DAY_FULL = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const mIdx = MONTHS_ORDER.indexOf(monthName);
  if (mIdx < 0 || weekNum < 1) return [];
  const lastDate = new Date(year, mIdx + 1, 0).getDate();
  const firstDow = new Date(year, mIdx, 1).getDay();
  const daysUntilSun = firstDow === 0 ? 0 : 7 - firstDow;
  const starts = [1];
  const ends   = [Math.min(1 + daysUntilSun, lastDate)];
  let cur = ends[0] + 1;
  while (cur <= lastDate) {
    starts.push(cur);
    ends.push(Math.min(cur + 6, lastDate));
    cur += 7;
  }
  const i = weekNum - 1;
  if (i < 0 || i >= starts.length) return [];
  const result = [];
  for (let d = starts[i]; d <= ends[i]; d++) {
    result.push({ date: d, dayName: DAY_FULL[new Date(year, mIdx, d).getDay()] });
  }
  return result;
};

const MonthPage = ({ month, year, pageNum, perfMap, perfDayMap, planMap, centerKeyMap, plannedWeeks, dailyPlanOverride, noFallbackDaily, userCenterKey, monthlySummary, viewMode = "both", activeDayData }) => {
  // Look up the justification note for a given day+center from active planning data
  const getActiveDayJustification = (date, centerKey) => {
    if (!activeDayData) return "";
    for (const week of (activeDayData || [])) {
      if (!week.days) continue;
      const de = week.days.find(d => d.date === date);
      if (!de) continue;
      return de[centerKey]?.justification || "";
    }
    return "";
  };

  // Look up per-day sites from the active planning's per-day data → [{ name, units }]
  const getActiveDaySites = (date, centerKey) => {
    if (!activeDayData) return null;
    for (const week of (activeDayData || [])) {
      if (!week.days) continue;
      const de = week.days.find(d => d.date === date);
      if (!de) continue;
      const cd = de[centerKey];
      if (!cd || cd.noCollection) return null;
      // New model: sites: [{ name, units }]
      if (cd.sites && cd.sites.length > 0) return cd.sites;
      // Legacy groups: [{ names[], units }] → flatten to individual sites
      if (cd.groups && cd.groups.length > 0)
        return cd.groups.flatMap(g => (g.names || []).map(name => ({ name, units: 0 })));
      // Oldest legacy: flat names array
      if (cd.names && cd.names.length > 0) return cd.names.map(name => ({ name, units: 0 }));
      return null;
    }
    return null;
  };
  const summary  = monthlySummary || SUMMARY.find(s => s.month === month);
  const weeks    = plannedWeeks || MONTHS_WEEKS[month] || [];
  const weekRows = weeks.filter(w => !w.label.startsWith("FIXED"));
  const fixedRow = weeks.find(w => w.label.startsWith("FIXED"));

  const showPlanned  = viewMode !== "performed";
  const showPerformed = viewMode !== "planned";
  const colsPerCenter = (showPlanned ? 3 : 0) + (showPerformed ? 5 : 0);
  const planTotalCols = showPlanned ? 2 : 0;
  const perfTotalCols = showPerformed ? 3 : 0;
  const totalCols = planTotalCols + perfTotalCols;

  const centerCols = [
    { key:"k",    label:"KIGALI RCBT",    sumKey:"kigali"    },
    { key:"b",    label:"BUTARE RCBT",    sumKey:"butare"    },
    { key:"ko",   label:"KARONGI RCBT",   sumKey:"karongi"   },
    { key:"ru",   label:"RUHENGERI RCBT", sumKey:"ruhengeri" },
    { key:"rw",   label:"RWAMAGANA RCBT", sumKey:"rwamagana" },
    { key:"rmth", label:"RMTH BB",        sumKey:"rmth"      },
    { key:"rnp",  label:"RNP",            sumKey:"rnp"       },
  ];
  const visibleCenterCols = userCenterKey ? centerCols.filter(c => c.key === userCenterKey) : centerCols;
  const monthNum = MONTHS_ORDER.indexOf(month) + 1;
  const totalColSpan = 2 + visibleCenterCols.length * colsPerCenter + totalCols;

  const getPerf = (centerKey, weekNum) => {
    const centerId = centerKeyMap[centerKey];
    if (!centerId || !perfMap[centerId]) return null;
    return perfMap[centerId][monthNum]?.[weekNum] || null;
  };

  const getDayPerf = (centerKey, dayNum) => {
    const centerId = centerKeyMap[centerKey];
    if (!centerId || !perfDayMap[centerId]) return null;
    return perfDayMap[centerId][monthNum]?.[dayNum] || null;
  };

  const getPlan = (centerKey, weekNum) => {
    const centerId = centerKeyMap[centerKey];
    if (!centerId || !planMap[centerId]) return null;
    return planMap[centerId][monthNum]?.[weekNum] || null;
  };

  const weekNums = weekRows.map((w) => {
    const m = w.label.match(/WEEK (\d+)/);
    return m ? Number(m[1]) : null;
  });

  const planCell    = (extra = {}) => ({ ...td(), background: C.totalWeek,    color: C.black, ...extra });
  const perfCell    = (extra = {}) => ({ ...td(), background: C.perfWeek,     color: C.black, fontStyle: "italic", ...extra });
  const twRowCell   = (extra = {}) => ({ ...td(), background: C.totalWeekRow, color: C.black, fontWeight: "bold", ...extra });

  return (
    <LandscapePage>
      <BlueHeader year={year} />
      <div style={{ fontWeight: "bold", fontSize: 9, textAlign: "center", marginBottom: 4 }}>
        ANNUAL BLOOD COLLECTION PLAN — {month} {year}
      </div>
      <div style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
      <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
        <colgroup>
          <col style={{ width: 34 }} />
          <col style={{ width: 58 }} />
          {visibleCenterCols.map(c => (
            <React.Fragment key={c.key}>
              {showPlanned && <><col style={{ width: 80 }} /><col style={{ width: 36 }} /><col style={{ width: 30 }} /></>}
              {showPerformed && <><col style={{ width: 80 }} /><col style={{ width: 30 }} /><col style={{ width: 36 }} /><col style={{ width: 42 }} /><col style={{ width: 60 }} /></>}
            </React.Fragment>
          ))}
          {showPlanned && <><col style={{ width: 34 }} /><col style={{ width: 40 }} /></>}
          {showPerformed && <><col style={{ width: 34 }} /><col style={{ width: 40 }} /><col style={{ width: 44 }} /></>}
        </colgroup>
        <thead>
          {/* Row 1: center names */}
          <tr>
            <th style={th(C.centerGreen, C.white, { fontSize: 9, textAlign: "center" })} colSpan={2} rowSpan={2}>
              {month}<br />{year}
            </th>
            {visibleCenterCols.map(c => (
              <th key={c.key} style={th(C.centerGreen, C.white, { fontSize: 8 })} colSpan={colsPerCenter}>{c.label}</th>
            ))}
            {showPlanned  && <th style={th(C.centerGreen, C.white, { fontSize: 7 })} colSpan={2}>PLAN<br />TOTAL</th>}
            {showPerformed && <th style={th(C.centerGreen, C.white, { fontSize: 7 })} colSpan={3}>PERF<br />TOTAL</th>}
          </tr>
          {/* Row 2: Planned / Performed sub-headers per center */}
          <tr>
            {visibleCenterCols.map(c => (
              <React.Fragment key={c.key}>
                {showPlanned  && <th style={th(C.totalWeek, C.black, { fontSize: 7, fontWeight: "bold" })} colSpan={3}>PLANNED</th>}
                {showPerformed && <th style={th(C.perfWeek,  C.black, { fontSize: 7, fontStyle: "italic" })} colSpan={5}>PERFORMED</th>}
              </React.Fragment>
            ))}
            {showPlanned  && <><th style={th(C.totalWeek, C.black, { fontSize: 7 })}>Units</th><th style={th(C.totalWeek, C.black, { fontSize: 7 })}>Sess</th></>}
            {showPerformed && <><th style={th(C.perfWeek, C.black, { fontSize: 7 })}>Sess</th><th style={th(C.perfWeek, C.black, { fontSize: 7 })}>Units</th><th style={th(C.perfWeek, C.black, { fontSize: 7 })}>Achiev.<br />Rate%</th></>}
          </tr>
          {/* Row 3: Sites / Sess / Units per sub-header */}
          <tr>
            <th style={th(C.centerGreen2, C.white, { fontSize: 7 })}>DATE</th>
            <th style={th(C.centerGreen2, C.white, { fontSize: 7 })}>DAYS</th>
            {visibleCenterCols.map(c => (
              <React.Fragment key={c.key}>
                {showPlanned  && <><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}>Sites</th><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}>Units</th><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}>Sess</th></>}
                {showPerformed && <><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}>Sites</th><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}>Units</th><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}>Sess</th><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}>Rate%</th><th style={th(C.centerGreen2, C.white, { fontSize: 7, minWidth: 60 })}>Comment</th></>}
              </React.Fragment>
            ))}
            {showPlanned  && <><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}></th><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}></th></>}
            {showPerformed && <><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}></th><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}></th><th style={th(C.centerGreen2, C.white, { fontSize: 7 })}></th></>}
          </tr>
        </thead>
        <tbody>
          {weekRows.map((w, wi) => {
            const weekNum = weekNums[wi];

            // Per-day sum helpers — used for TOTAL WEEK row computation
            const _weekDays   = getWeekDaysList(month, weekNum, year);
            const _getDayP    = (date) => dailyPlanOverride?.[date] || (noFallbackDaily ? undefined : DAILY_PLAN_2026[month]?.[date]);
            const _wdHasData  = (ck) => _weekDays.some(({ date }) => { const dp = _getDayP(date); return dp && (dp.sess?.[ck] || dp.units?.[ck]); });
            const _wdSess     = (ck) => _weekDays.reduce((s, { date }) => s + (_getDayP(date)?.sess?.[ck]  || 0), 0);
            const _wdUnits    = (ck) => _weekDays.reduce((s, { date }) => s + (_getDayP(date)?.units?.[ck] || 0), 0);

            const planTotSess  = visibleCenterCols.reduce((s, c) => { const p = getPlan(c.key, weekNum); return s + (p ? p.sessions : (_wdHasData(c.key) ? _wdSess(c.key)  : (w[c.key]?.[1] || 0))); }, 0);
            const planTotUnits = visibleCenterCols.reduce((s, c) => { const p = getPlan(c.key, weekNum); return s + (p ? p.units    : (_wdHasData(c.key) ? _wdUnits(c.key) : (w[c.key]?.[2] || 0))); }, 0);
            const perfTotSess  = visibleCenterCols.reduce((s, c) => { const p = getPerf(c.key, weekNum); return s + (p ? p.sessions : 0); }, 0);
            const perfTotUnits = visibleCenterCols.reduce((s, c) => { const p = getPerf(c.key, weekNum); return s + (p ? p.units : 0); }, 0);
            const hasPerf      = visibleCenterCols.some(c => getPerf(c.key, weekNum));

            return (
              <React.Fragment key={w.label}>
                {/* Gold week section header */}
                <tr>
                  <td colSpan={2} style={{ ...td(), background: C.weekSection, color: C.black, fontWeight: "bold", fontSize: 7, paddingLeft: 4 }}>{month}</td>
                  <td colSpan={visibleCenterCols.length * colsPerCenter + totalCols} style={{ ...td(), background: C.weekSection, color: C.black, fontWeight: "bold", fontSize: 8, textAlign: "center" }}>
                    WEEK {weekNum}
                  </td>
                </tr>
                {/* Individual day rows — one <tr> per site, DATE/DAYS/totals rowSpanned */}
                {getWeekDaysList(month, weekNum, year).map(({ date, dayName }) => {
                  const dayPlan  = dailyPlanOverride?.[date] || (noFallbackDaily ? undefined : DAILY_PLAN_2026[month]?.[date]);
                  const holiday  = dayPlan?.holiday;
                  const noColSet = new Set(dayPlan?.noCol || []);
                  const allHoliday = holiday != null && (dayPlan?.noCol || []).length === 0
                    && visibleCenterCols.every(c => !(dayPlan?.[c.key] || []).length);
                  const dayPlanTotSess  = visibleCenterCols.reduce((s, c) => s + (dayPlan?.sess?.[c.key] || 0), 0);
                  const dayPlanTotUnits = visibleCenterCols.reduce((s, c) => s + (dayPlan?.units?.[c.key] || 0), 0);
                  const dayPerfList     = visibleCenterCols.map(c => getDayPerf(c.key, date));
                  const hasAnyDayPerf   = dayPerfList.some(Boolean);
                  const dayPerfTotSess  = dayPerfList.reduce((s, p) => s + (p ? p.sessions : 0), 0);
                  const dayPerfTotUnits = dayPerfList.reduce((s, p) => s + (p ? p.units    : 0), 0);

                  const centerSites = visibleCenterCols.map((c, ci) => {
                    // Per-site planned data: [{ name, units }] from active ABCPlanningManager
                    const activeSites = getActiveDaySites(date, c.key);
                    // Flat planned site names for mismatch detection and legacy fallback
                    const daySites = activeSites
                      ? activeSites.map(s => cleanSite(s.name)).filter(Boolean)
                      : (dayPlan?.[c.key] || []).map(cleanSite);
                    const noCollection = allHoliday || (noColSet.has(c.key) && daySites.length === 0);
                    const dayPerf        = dayPerfList[ci];
                    const perfSiteItems  = dayPerf ? (dayPerf.siteItems || []) : [];
                    const perfSites      = perfSiteItems.length > 0
                      ? perfSiteItems.map(si => cleanSite(si.name)).filter(Boolean)
                      : (dayPerf ? dayPerf.siteNames.map(cleanSite) : []);
                    const planRows = noCollection ? 1 : (activeSites ? activeSites.length : daySites.length) || 1;
                    const numRows = showPlanned && showPerformed
                      ? Math.max(planRows, perfSiteItems.length || 1)
                      : showPlanned ? planRows : Math.max(1, perfSiteItems.length || 1);
                    // Mismatch detection (flat comparison)
                    const hasMismatch = showPlanned && showPerformed && !noCollection && daySites.length > 0 && dayPerf && (
                      daySites.some(s => !perfSites.some(ps => ps.toLowerCase() === s.toLowerCase())) ||
                      perfSites.some(ps => !daySites.some(s => s.toLowerCase() === ps.toLowerCase()))
                    );
                    const missingPerfSet = new Set(
                      daySites.filter(s => !perfSites.some(ps => ps.toLowerCase() === s.toLowerCase()))
                        .map(s => s.toLowerCase())
                    );
                    const unexpectedPerfSet = new Set(
                      perfSites.filter(ps => !daySites.some(s => s.toLowerCase() === ps.toLowerCase()))
                        .map(ps => ps.toLowerCase())
                    );
                    const justification = getActiveDayJustification(date, c.key);
                    return { c, daySites, activeSites, noCollection, dayPerf, perfSites, perfSiteItems, numRows, hasMismatch, missingPerfSet, unexpectedPerfSet, justification };
                  });
                  const maxRows = Math.max(1, ...centerSites.map(cs => cs.numRows));

                  return Array.from({ length: maxRows }, (_, si) => (
                    <tr key={`${date}-${si}`}>
                      {si === 0 && (
                        holiday ? (
                          <td colSpan={2} rowSpan={maxRows} style={{ ...td(), background: C.weekSection, color: C.black, fontStyle: "italic", fontWeight: "bold", fontSize: 7, textAlign: "center", verticalAlign: "middle" }}>{holiday}</td>
                        ) : (
                          <>
                            <td rowSpan={maxRows} style={{ ...td(), fontSize: 8, fontWeight: "bold", textAlign: "center", verticalAlign: "middle" }}>{ordinal(date)}</td>
                            <td rowSpan={maxRows} style={{ ...td(), fontSize: 7, textAlign: "center", verticalAlign: "middle" }}>{dayName}</td>
                          </>
                        )
                      )}
                      {centerSites.map(({ c, daySites, activeSites, noCollection, dayPerf, perfSites, perfSiteItems, hasMismatch, missingPerfSet, unexpectedPerfSet, justification }) => {
                        // Planned: each activeSite[si] is one row with its own name + units
                        const planSite      = activeSites?.[si] || null;
                        const planSiteName  = planSite ? cleanSite(planSite.name) : (daySites[si] || "");
                        const planSiteUnits = planSite ? (planSite.units || 0) : 0;
                        const isMissingPerf = hasMismatch && planSiteName && missingPerfSet.has(planSiteName.toLowerCase());
                        // Performed: each perfSiteItems[si] is one row with its own name + units
                        const perfItem     = perfSiteItems[si] || null;
                        const perfSiteName = perfItem ? cleanSite(perfItem.name) : (perfSites[si] || "");
                        const perfSiteUnits = perfItem ? (perfItem.units || 0) : 0;
                        const isUnexpected  = hasMismatch && perfSiteName && unexpectedPerfSet.has(perfSiteName.toLowerCase());
                        const planCols = activeSites ? activeSites.length : daySites.length;

                        return (
                          <React.Fragment key={c.key}>
                            {noCollection ? (
                              <>
                                {showPlanned && si === 0 && (
                                  <td colSpan={3} rowSpan={maxRows} style={{ ...td(), background: "#5a5a5a", color: "white", textAlign: "center", fontSize: 5, fontStyle: "italic", padding: "1px 2px", verticalAlign: "middle" }}>
                                    No blood collection
                                  </td>
                                )}
                                {showPerformed && (
                                  <>
                                    <td style={{ ...perfCell({ fontSize: 6, lineHeight: 1.3, overflow: "hidden", overflowWrap: "break-word" }) }}>{perfSiteName}</td>
                                    <td style={{ ...perfCell({ textAlign: "right", fontSize: 7, verticalAlign: "middle" }) }}>{perfSiteUnits ? fmt(perfSiteUnits) : ""}</td>
                                    {si === 0 && (
                                      <>
                                        <td rowSpan={maxRows} style={{ ...perfCell({ textAlign: "center", fontSize: 7, verticalAlign: "middle" }) }}>{dayPerf?.sessions || ""}</td>
                                        <td rowSpan={maxRows} style={{ ...perfCell({ textAlign: "center", fontSize: 7, fontWeight: "bold", verticalAlign: "middle" }) }}>{"—"}</td>
                                        <td rowSpan={maxRows} style={{ ...perfCell({ fontSize: 6, verticalAlign: "middle" }) }}></td>
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {showPlanned && (
                                  <>
                                    {/* Site: one per row, own name */}
                                    <td style={{ ...planCell({ fontSize: 6, lineHeight: 1.4, overflow: "hidden", overflowWrap: "break-word", background: isMissingPerf ? "#fff3cd" : undefined, verticalAlign: "middle" }) }}>
                                      {si < planCols ? planSiteName : ""}
                                    </td>
                                    {/* Units: PER SITE (not rowspanned) */}
                                    <td style={{ ...planCell({ textAlign: "right", fontSize: 7, verticalAlign: "middle", background: isMissingPerf ? "#fff3cd" : undefined }) }}>
                                      {si < planCols && planSiteUnits ? fmt(planSiteUnits) : ""}
                                    </td>
                                    {/* Sessions: rowspanned across all rows for this day+center */}
                                    {si === 0 && (
                                      <td rowSpan={maxRows} style={{ ...planCell({ textAlign: "center", fontSize: 7, verticalAlign: "middle", background: hasMismatch ? "#fff3cd" : undefined }) }}>
                                        {dayPlan?.sess?.[c.key] || ""}
                                      </td>
                                    )}
                                  </>
                                )}
                                {showPerformed && (
                                  <>
                                    {/* Performed site: one per row */}
                                    <td style={{ ...perfCell({ fontSize: 6, lineHeight: 1.3, overflow: "hidden", overflowWrap: "break-word", background: isUnexpected ? "#e8f4fd" : undefined }) }}>
                                      {perfSiteName}
                                    </td>
                                    {/* Units: PER SITE (not rowspanned) */}
                                    <td style={{ ...perfCell({ textAlign: "right", fontSize: 7, verticalAlign: "middle" }) }}>
                                      {perfSiteUnits ? fmt(perfSiteUnits) : ""}
                                    </td>
                                    {si === 0 && (
                                      <>
                                        <td rowSpan={maxRows} style={{ ...perfCell({ textAlign: "center", fontSize: 7, verticalAlign: "middle" }) }}>{dayPerf?.sessions || ""}</td>
                                        <td rowSpan={maxRows} style={{ ...perfCell({ textAlign: "center", fontSize: 7, fontWeight: "bold", verticalAlign: "middle", background: hasMismatch ? "#fff3cd" : undefined }) }}>
                                          {dayPerf?.units && dayPlan?.units?.[c.key]
                                            ? Math.round(dayPerf.units / dayPlan.units[c.key] * 100) + "%"
                                            : ""}
                                        </td>
                                        <td rowSpan={maxRows} style={{ ...perfCell({ fontSize: 6, verticalAlign: "middle", padding: "2px 4px", background: hasMismatch && justification ? "#fff8e1" : undefined, fontStyle: "normal" }) }}>
                                          {hasMismatch && justification
                                            ? <span style={{ color: "#856404" }}>{justification}</span>
                                            : ""}
                                        </td>
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </React.Fragment>
                        );
                      })}
                      {si === 0 && (
                        <>
                          {showPlanned && (
                            <>
                              <td rowSpan={maxRows} style={{ ...planCell({ textAlign: "right",  fontSize: 7, verticalAlign: "middle" }) }}>{dayPlanTotUnits ? fmt(dayPlanTotUnits) : ""}</td>
                              <td rowSpan={maxRows} style={{ ...planCell({ textAlign: "center", fontSize: 7, verticalAlign: "middle" }) }}>{dayPlanTotSess || ""}</td>
                            </>
                          )}
                          {showPerformed && (
                            <>
                              <td rowSpan={maxRows} style={{ ...perfCell({ textAlign: "center", fontSize: 7, verticalAlign: "middle" }) }}>{hasAnyDayPerf ? dayPerfTotSess : ""}</td>
                              <td rowSpan={maxRows} style={{ ...perfCell({ textAlign: "right",  fontSize: 7, verticalAlign: "middle" }) }}>{hasAnyDayPerf && dayPerfTotUnits ? fmt(dayPerfTotUnits) : ""}</td>
                              <td rowSpan={maxRows} style={{ ...perfCell({ textAlign: "center", fontSize: 7, fontWeight: "bold", verticalAlign: "middle" }) }}>
                                {hasAnyDayPerf && dayPerfTotUnits && dayPlanTotUnits
                                  ? Math.round(dayPerfTotUnits / dayPlanTotUnits * 100) + "%"
                                  : ""}
                              </td>
                            </>
                          )}
                        </>
                      )}
                    </tr>
                  ));
                })}
                {/* TOTAL WEEK row */}
                <tr>
                  <td colSpan={2} style={{ ...twRowCell({ fontSize: 7, textAlign: "center" }) }}>TOTAL {w.label}</td>
                  {visibleCenterCols.map(c => {
                    const plan = getPlan(c.key, weekNum);
                    const perf = getPerf(c.key, weekNum);
                    const planSess  = plan ? plan.sessions  : (_wdHasData(c.key) ? _wdSess(c.key)  : (w[c.key]?.[1] || 0));
                    const planUnits = plan ? plan.units     : (_wdHasData(c.key) ? _wdUnits(c.key) : (w[c.key]?.[2] || 0));

                    const perfSites = perf ? "Sites" : "—";

                    const configSiteNames = (w && w[`${c.key}Names`]) || [];
                    const weeklyDailySites = configSiteNames.length === 0 ? (() => {
                      const unique = new Set();
                      getWeekDaysList(month, weekNum, year).forEach(({ date }) => {
                        const dp = dailyPlanOverride?.[date] || (noFallbackDaily ? undefined : DAILY_PLAN_2026[month]?.[date]);
                        (dp?.[c.key] || []).forEach(s => unique.add(s));
                      });
                      return [...unique];
                    })() : [];
                    const effectiveSiteNames = configSiteNames.length > 0 ? configSiteNames : weeklyDailySites;
                    const planSiteNames = plan && plan.siteNames && plan.siteNames.length
                      ? plan.siteNames.join(", ")
                      : effectiveSiteNames.length > 0 ? effectiveSiteNames.join(", ") : "—";

                    const weekRate = perf && planUnits
                      ? Math.round(perf.units / planUnits * 100) + "%"
                      : "—";

                    return (
                      <React.Fragment key={c.key}>
                        {showPlanned && (
                          <>
                            <td style={{ ...twRowCell({ fontSize: 7, lineHeight: 1.3 }) }}>Sites</td>
                            <td style={{ ...twRowCell({ textAlign: "right",  fontSize: 7 }) }}>{fmt(planUnits)}</td>
                            <td style={{ ...twRowCell({ textAlign: "center", fontSize: 7 }) }}>{planSess || "—"}</td>
                          </>
                        )}
                        {showPerformed && (
                          <>
                            <td style={{ ...twRowCell({ fontSize: 7, lineHeight: 1.3, fontStyle: "italic" }) }}>{perfSites}</td>
                            <td style={{ ...twRowCell({ textAlign: "center", fontSize: 7, fontStyle: "italic" }) }}>{perf ? perf.sessions : "—"}</td>
                            <td style={{ ...twRowCell({ textAlign: "right",  fontSize: 7, fontStyle: "italic" }) }}>{perf ? fmt(perf.units) : "—"}</td>
                            <td style={{ ...twRowCell({ textAlign: "center", fontSize: 7, fontWeight: "bold" }) }}>{weekRate}</td>
                            <td style={{ ...twRowCell({ fontSize: 7 }) }}></td>
                          </>
                        )}
                      </React.Fragment>
                    );
                  })}
                  {showPlanned && (
                    <>
                      <td style={{ ...twRowCell({ textAlign: "right",  fontSize: 7 }) }}>{fmt(planTotUnits)}</td>
                      <td style={{ ...twRowCell({ textAlign: "center", fontSize: 7 }) }}>{planTotSess}</td>
                    </>
                  )}
                  {showPerformed && (
                    <>
                      <td style={{ ...twRowCell({ textAlign: "center", fontSize: 7, fontStyle: "italic" }) }}>{hasPerf ? perfTotSess  : "—"}</td>
                      <td style={{ ...twRowCell({ textAlign: "right",  fontSize: 7, fontStyle: "italic" }) }}>{hasPerf ? fmt(perfTotUnits) : "—"}</td>
                      <td style={{ ...twRowCell({ textAlign: "center", fontSize: 7, fontWeight: "bold" }) }}>
                        {hasPerf && perfTotUnits && planTotUnits
                          ? Math.round(perfTotUnits / planTotUnits * 100) + "%"
                          : "—"}
                      </td>
                    </>
                  )}
                </tr>

              </React.Fragment>
            );
          })}

          {/* Fixed Site & Bus */}
          {fixedRow && (
            <>
              <tr>
                <td colSpan={totalColSpan} style={{ ...td(), background: C.fixedSite, color: C.black, fontWeight: "bold", fontSize: 7, paddingLeft: 6 }}>
                  FIXED SITE AND BUS
                </td>
              </tr>
              <tr style={{ background: "#DAEEF3" }}>
                <td colSpan={2} style={{ ...td(), fontSize: 6, fontWeight: "bold", textAlign: "center" }}>FIXED SITE</td>
                {visibleCenterCols.map(c => (
                  <React.Fragment key={c.key}>
                    {showPlanned && (
                      <>
                        <td style={{ ...planCell({ fontSize: 5 }) }}>Fixed site</td>
                        <td style={{ ...planCell({ textAlign: "right",  fontSize: 6 }) }}>{fixedRow[c.key]?.[2] ? fmt(fixedRow[c.key][2]) : ""}</td>
                        <td style={{ ...planCell({ textAlign: "center", fontSize: 6 }) }}>{fixedRow[c.key]?.[1] ?? ""}</td>
                      </>
                    )}
                    {showPerformed && <td colSpan={5} style={{ ...td(), background: "transparent", textAlign: "center", fontSize: 5, color: "#888" }}>—</td>}
                  </React.Fragment>
                ))}
                {showPlanned && (
                  <>
                    <td style={{ ...planCell({ textAlign: "center", fontWeight: "bold", fontSize: 6 }) }}>{fixedRow.t[0]}</td>
                    <td style={{ ...planCell({ textAlign: "right",  fontWeight: "bold", fontSize: 6 }) }}>{fmt(fixedRow.t[1])}</td>
                  </>
                )}
                {showPerformed && <td colSpan={3} style={{ ...td() }}></td>}
              </tr>
              {fixedRow.bus && (
                <tr style={{ background: C.busRow }}>
                  <td colSpan={2} style={{ ...td(), fontSize: 6, fontWeight: "bold", textAlign: "center" }}>BUS</td>
                  {visibleCenterCols.map(c => (
                    c.key === "k" ? (
                      <td key={c.key} colSpan={colsPerCenter} style={{ ...td(), textAlign: "center", fontSize: 6 }}>BUS — Kigali</td>
                    ) : (
                      <td key={c.key} colSpan={colsPerCenter} style={{ ...td(), background: C.noBlood, color: "#bbb", fontSize: 5, textAlign: "center" }}>
                        No blood collection
                      </td>
                    )
                  ))}
                  {showPlanned && (
                    <>
                      <td style={{ ...td(), textAlign: "center", fontWeight: "bold", fontSize: 6 }}>{fixedRow.bus[0]}</td>
                      <td style={{ ...td(), textAlign: "right",  fontWeight: "bold", fontSize: 6 }}>{fmt(fixedRow.bus[1])}</td>
                    </>
                  )}
                  {showPerformed && <td colSpan={3} style={{ ...td() }}></td>}
                </tr>
              )}
            </>
          )}

          {/* TOTAL MONTH row — gold */}
          {summary && (() => {
            const visMonthSess  = visibleCenterCols.reduce((s, c) => s + (summary[c.sumKey]?.[0] || 0), 0);
            const visMonthUnits = visibleCenterCols.reduce((s, c) => s + (summary[c.sumKey]?.[1] || 0), 0);
            return (
              <tr style={{ background: C.totalMonth }}>
                <td colSpan={2} style={{ ...td(), color: C.black, fontWeight: "bold", fontSize: 7, textAlign: "center" }}>TOTAL {month}</td>
                {visibleCenterCols.map(c => (
                  <React.Fragment key={c.key}>
                    {showPlanned && (
                      <>
                        <td colSpan={2} style={{ ...td(), textAlign: "right", color: C.black, fontWeight: "bold", fontSize: 7 }}>{fmt(summary[c.sumKey]?.[1] ?? 0)}</td>
                        <td style={{ ...td(), textAlign: "center", color: C.black, fontWeight: "bold", fontSize: 7 }}>{summary[c.sumKey]?.[0] ?? 0} sess</td>
                      </>
                    )}
                    {showPerformed && <td colSpan={5} style={{ ...td() }}></td>}
                  </React.Fragment>
                ))}
                {showPlanned && (
                  <>
                    <td style={{ ...td(), textAlign: "center", color: C.black, fontWeight: "bold", fontSize: 7 }}>{visMonthSess}</td>
                    <td style={{ ...td(), textAlign: "right", color: C.black, fontWeight: "bold", fontSize: 7 }}>{fmt(visMonthUnits)}</td>
                  </>
                )}
                {showPerformed && <td colSpan={3} style={{ ...td() }}></td>}
              </tr>
            );
          })()}
        </tbody>
      </table>
      </div>
      <PageFooter pageNum={pageNum} />
    </LandscapePage>
  );
};

// ─── Derive Summary from planData ────────────────────────────────────────────
const PLAN_CENTER_MAP = { k: "kigali", b: "butare", ko: "karongi", ru: "ruhengeri", rw: "rwamagana" };

const computeSummaryFromPlanData = (planData) => {
  if (!planData) return null;
  const rows = MONTHS_ORDER.map(month => {
    const weeks = planData[month] || [];
    const row = { month };
    let rcbtSess = 0, rcbtUnits = 0;
    Object.entries(PLAN_CENTER_MAP).forEach(([ck, label]) => {
      let sess = 0, units = 0;
      weeks.forEach(w => {
        sess  += (w[ck]?.[1] || 0);
        units += (w[ck]?.[2] || 0);
      });
      row[label] = [sess, units];
      rcbtSess  += sess;
      rcbtUnits += units;
    });
    row.rcbtTotal = [rcbtSess, rcbtUnits];
    let rmthSess = 0, rmthUnits = 0, rnpSess = 0, rnpUnits = 0;
    weeks.forEach(w => {
      rmthSess  += (w.rmth?.[1] || 0);
      rmthUnits += (w.rmth?.[2] || 0);
      rnpSess   += (w.rnp?.[1]  || 0);
      rnpUnits  += (w.rnp?.[2]  || 0);
    });
    row.rmth  = [rmthSess,  rmthUnits];
    row.rnp   = [rnpSess,   rnpUnits];
    row.grand = [rcbtSess + rmthSess + rnpSess, rcbtUnits + rmthUnits + rnpUnits];
    return row;
  });
  const total = { kigali:[0,0], butare:[0,0], karongi:[0,0], ruhengeri:[0,0], rwamagana:[0,0],
                  rcbtTotal:[0,0], rmth:[0,0], rnp:[0,0], grand:[0,0] };
  rows.forEach(row => {
    Object.keys(total).forEach(k => {
      if (row[k]) { total[k][0] += row[k][0]; total[k][1] += row[k][1]; }
    });
  });
  return { rows, total };
};

const computeSummaryFromDailyPlan = (dailyPlan) => {
  if (!dailyPlan) return null;
  let hasData = false;
  const rows = MONTHS_ORDER.map(month => {
    const monthPlan = dailyPlan[month] || {};
    const row = { month };
    let rcbtSess = 0, rcbtUnits = 0;
    Object.entries(PLAN_CENTER_MAP).forEach(([ck, label]) => {
      let sess = 0, units = 0;
      Object.values(monthPlan).forEach(dayData => {
        if (dayData && !(dayData.noCol || []).includes(ck)) {
          sess  += dayData.sess?.[ck]  || 0;
          units += dayData.units?.[ck] || 0;
        }
      });
      if (sess > 0 || units > 0) hasData = true;
      row[label] = [sess, units];
      rcbtSess  += sess;
      rcbtUnits += units;
    });
    row.rcbtTotal = [rcbtSess, rcbtUnits];
    row.rmth = [0, 0]; row.rnp = [0, 0];
    row.grand = [rcbtSess, rcbtUnits];
    return row;
  });
  if (!hasData) return null;
  const total = { kigali:[0,0], butare:[0,0], karongi:[0,0], ruhengeri:[0,0], rwamagana:[0,0],
                  rcbtTotal:[0,0], rmth:[0,0], rnp:[0,0], grand:[0,0] };
  rows.forEach(row => { Object.keys(total).forEach(k => { if (row[k]) { total[k][0] += row[k][0]; total[k][1] += row[k][1]; } }); });
  return { rows, total };
};

// ══════════════════════════════════════════════════════════════════════════════
// STATIC ANNUAL PLAN DATA — RDF (RMTH BB) and RNP
// ══════════════════════════════════════════════════════════════════════════════
const RDF_SECTIONS = [
  {
    months: ["JANUARY","APRIL","JULY","OCTOBER"],
    label: "ESTIMATED SESS. / UNITS 1",
    sites: [
      { name: "BMTC Nasho",                        rows: [["11-12/01/2026",2,300],["19-20/04/2026",2,300],["07-08/07/2026",2,300],["04-05/10/2026",2,300]] },
      { name: "Gatsibo - Nyagatare",               rows: [["13-17/01/2026",5,200],["14-18/04/2026",5,200],["14-18/07/2026",5,200],["10-14/10/2026",5,200]] },
      { name: "Kimihurura",                         rows: [["20/01/2026",1,110],   ["23/04/2026",1,110],   ["21/07/2026",1,110],   ["15/10/2026",1,110]]   },
      { name: "Busanza - Nyanza",                  rows: [["25-26/01/2026",2,70],  ["28-29/04/2026",2,70], ["29-30/07/2026",2,70], ["07-08/10/2026",2,70]] },
      { name: "Ngoma - Kirehe",                    rows: [["21-24/01/2026",4,120], ["09-13/04/2026",4,120],["09-12/07/2026",4,120],["17-20/10/2026",4,120]] },
    ],
    estimated: [[14,800],[14,800],[14,800],[14,800]], totalRow: [56,3200],
  },
  {
    months: ["FEBRUARY","MAY","AUGUST","NOVEMBER"],
    label: "ESTIMATED SESS. / UNITS 2",
    sites: [
      { name: "Rubavu - Mukamira",                  rows: [["06-07/02/2026",2,86], ["2-3/05/2026",2,86],   ["09-10/08/2026",2,86],  ["6-7/11/2026",2,86]]   },
      { name: "Musanze - Nyakinama",               rows: [["3-5/02/2026",3,120],  ["5-7/05/2026",3,120],  ["04-06/08/2026",3,120], ["03-05/11/2026",3,120]] },
      { name: "Bigogwe",                            rows: [["08-09/02/2026",2,500],["12-13/05/2026",2,500],["12-13/08/2026",2,500], ["8-9/11/2026",2,500]]  },
      { name: "WB Rubavu",                         rows: [["10/02/2026",1,90],    ["04/05/2026",1,90],    ["14/08/2026",1,90],     ["10/11/2026",1,90]]    },
      { name: "WB Karongi",                        rows: [["11/02/2026",1,50],    ["14/05/2026",1,50],    ["01/08/2026",1,50],     ["11/11/2026",1,50]]    },
      { name: "WB Nyamasheke",                     rows: [["12/02/2026",1,50],    ["15/05/2026",1,50],    ["16/08/2026",1,50],     ["12/11/2026",1,50]]    },
      { name: "Rutsiro - Karongi - Nyamasheke",    rows: [["13-15/02/2026",3,120],["16-18/05/2026",3,120],["17-19/08/2026",3,120], ["13-15/11/2026",3,120]] },
      { name: "Rusizi",                             rows: [["16-18/02/2026",3,105],["19-21/05/2026",3,105],["21-23/08/2026",3,105], ["20-22/11/2026",3,105]] },
      { name: "CTC Gabiro",                        rows: [["22-23/02/2026",2,450],["24-25/05/2026",2,450],["30-31/08/2026",2,450], ["29-30/11/2026",2,450]] },
    ],
    estimated: [[18,1571],[18,1571],[18,1571],[18,1571]], totalRow: [72,6284],
  },
  {
    months: ["MARCH","JUNE","SEPTEMBER","DECEMBER"],
    label: "ESTIMATED SESS. / UNITS 3",
    sites: [
      { name: "Nyaruguru - Nyamagabe",             rows: [["27-31/03/2026",5,185],["09-13/06/2026",5,185],["07-11/09/2026",5,185], ["8-12/12/2026",5,220]]  },
      { name: "RMA Gako",                          rows: [["01/03/2026",1,200],   ["07/06/2026",1,200],   ["06/09/2026",1,200],    ["06/12/2026",1,200]]    },
      { name: "Burera - Gicumbi",                  rows: [["03-05/03/2026",3,90], ["02-04/06/2026",3,90], ["12-14/09/2026",3,90],  ["01-03/12/2026",3,90]]  },
      { name: "Kanombe Barracks",                  rows: [["06-07/03/2026",2,250],["05-06/06/2026",2,250],["04-05/09/2026",2,250], ["04-05/12/2026",2,250]]  },
      { name: "Huye - Gisagara",                   rows: [["11-13/03/2026",3,105],["23-25/06/2026",3,105],["15-17/09/2026",3,105], ["15-17/12/2026",3,105]]  },
      { name: "Kamonyi - Muhanga",                 rows: [["17-19/03/2026",3,90], ["16-18/06/2026",3,90], ["22-24/09/2026",3,90],  ["21-23/12/2026",3,90]]  },
      { name: "Kigali (Kami, Rebero, Mont Kigali)", rows: [["24-26/03/2026",3,270],["19-21/06/2026",3,270],["18-20/09/2026",3,270], ["18-20/12/2026",3,250]]  },
    ],
    estimated: [[20,1190],[20,1190],[20,1190],[20,1205]], totalRow: [80,4775],
  },
];
const RDF_GRAND_TOTAL = [[52,3561],[52,3561],[52,3561],[52,3576],[208,14259]];

const RNP_SECTIONS = [
  {
    months: ["JANUARY","APRIL","JULY","OCTOBER"],
    label: "ESTIMATED UNITS 1",
    sites: [
      { name: "PTS Gishari",                rows: [["18/01/2026",1,350],["26/04/2026",1,200],["19/07/2026",1,350],["18/10/2026",1,400]] },
      { name: "EASTERN region",             rows: [null,               ["25/04/2026",1,60], ["18/07/2026",1,60], ["17/10/2026",1,60]]  },
      { name: "Interforce Kimironko (SIF)", rows: [["27/01/2026",1,90], ["22/04/2026",1,90], ["22/07/2026",1,90], ["22/10/2026",1,90]]  },
      { name: "Northern Region",            rows: [null,               ["02/04/2026",1,60], ["02/07/2026",1,60], ["02/10/2026",1,60]]  },
    ],
    estimated: [[2,440],[4,410],[4,560],[4,610]], totalRow: [14,2020],
  },
  {
    months: ["FEBRUARY","MAY","AUGUST","NOVEMBER"],
    label: "ESTIMATED UNITS 2",
    sites: [
      { name: "Headquarter Kacyiru", rows: [["19/02/2026",1,80], ["09/05/2026",1,80], ["23/08/2026",1,80], ["18/11/2026",1,80]]  },
      { name: "CTTC Mayange",        rows: [["08/02/2026",1,100],["10/05/2026",1,100],["16/08/2026",1,100],["02/11/2026",1,100]] },
      { name: "Central Region",      rows: [["20/02/2026",1,60], null,                ["22/08/2026",1,60], ["19/11/2026",1,60]]  },
    ],
    estimated: [[3,240],[2,180],[3,240],[3,240]], totalRow: [11,900],
  },
  {
    months: ["MARCH","JUNE","SEPTEMBER","DECEMBER"],
    label: "ESTIMATED UNITS 3",
    sites: [
      { name: "Muhima Traffic Police", rows: [["15/03/2026",1,65], ["14/06/2026",1,65], ["13/09/2026",1,65], ["13/12/2026",1,65]]  },
      { name: "NPC Musanze",           rows: [["08/03/2026",1,150],["15/06/2026",1,150],["14/09/2026",1,150],["27/12/2026",1,150]] },
      { name: "SOUTHERN Region",       rows: [["14/03/2026",1,60], ["08/06/2026",1,60], null,               ["07/12/2026",1,60]]  },
      { name: "Western region",        rows: [["20/03/2026",1,60], ["27/06/2026",1,60], ["12/09/2026",1,60], null]                },
    ],
    estimated: [[4,335],[4,335],[3,275],[3,275]], totalRow: [14,1220],
  },
];
const RNP_GRAND_TOTAL = [[9,1015],[10,925],[10,1075],[10,1125],[39,4140]];

// ── Annual Plan page component (shared by RDF and RNP) ───────────────────────
const AnnualPlanPage = ({ title, sections, grandTotal, year, unitsLabel = "UNITS" }) => {
  const green = C.summaryTotal, orange = C.weekSection, sectGreen = C.centerGreen2;
  const fmtN  = n => (n || 0).toLocaleString();
  const noBlood = { background: C.noBlood, color: C.white, fontStyle: "italic", textAlign: "center", fontSize: 7 };
  return (
    <LandscapePage>
      <BlueHeader year={year} />
      <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 11, margin: "8px 0 5px" }}>
        {title} - {year}
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed", fontSize: 8 }}>
        <colgroup>
          <col style={{ width: "20%" }} />
          {[0,1,2,3].map(i => <React.Fragment key={i}><col style={{ width: "10.5%" }} /><col style={{ width: "4%" }} /><col style={{ width: "3.5%" }} /></React.Fragment>)}
          <col style={{ width: "4.5%" }} /><col style={{ width: "3.5%" }} />
        </colgroup>
        <thead>
          <tr>
            <th style={th(orange, C.black)}>DATES / LOCATION</th>
            {[0,1,2,3].map(i => <React.Fragment key={i}>
              <th style={th(orange, C.black)}>DATES</th>
              <th style={th(orange, C.black)}>{unitsLabel}</th>
              <th style={th(orange, C.black)}>SESS.</th>
            </React.Fragment>)}
            <th style={th(orange, C.black)} colSpan={2}>TOTAL</th>
          </tr>
          <tr>
            <th style={th(orange, C.black)} />
            {[0,1,2,3].map(i => <React.Fragment key={i}><th style={th(orange, C.black)} /><th style={th(orange, C.black)}>{unitsLabel}</th><th style={th(orange, C.black)}>SESS.</th></React.Fragment>)}
            <th style={th(green, C.white)}>{unitsLabel}</th>
            <th style={th(green, C.white)}>SESS.</th>
          </tr>
        </thead>
        <tbody>
          {sections.map((sec, sIdx) => (
            <React.Fragment key={sIdx}>
              <tr>
                <td style={th(sectGreen, C.white, { textAlign: "left", paddingLeft: 4 })}>SITES / MONTHS</td>
                {sec.months.map(m => <td key={m} style={th(sectGreen, C.white)} colSpan={3}>{m}</td>)}
                <td style={th(green, C.white)}>{unitsLabel}</td>
                <td style={th(green, C.white)}>SESS.</td>
              </tr>
              {sec.sites.map((site, ri) => {
                const totS = site.rows.reduce((a,r) => a+(r?r[1]:0), 0);
                const totU = site.rows.reduce((a,r) => a+(r?r[2]:0), 0);
                const rowBg = ri % 2 === 0 ? "#FFFF99" : "#FFFFFF";
                return (
                  <tr key={ri}>
                    <td style={td({ background: rowBg, fontWeight: "bold", wordBreak: "break-word", lineHeight: 1.2 })}>{site.name}</td>
                    {site.rows.map((r, qi) => r ? (
                      <React.Fragment key={qi}>
                        <td style={td({ background: rowBg, textAlign: "center", fontSize: 7 })}>{r[0]}</td>
                        <td style={td({ background: rowBg, textAlign: "center" })}>{fmtN(r[2])}</td>
                        <td style={td({ background: rowBg, textAlign: "center" })}>{r[1]}</td>
                      </React.Fragment>
                    ) : (
                      <td key={qi} colSpan={3} style={{ ...td(), ...noBlood }}>No blood collection</td>
                    ))}
                    <td style={td({ background: green, color: C.white, fontWeight: "bold", textAlign: "center" })}>{fmtN(totU)}</td>
                    <td style={td({ background: green, color: C.white, fontWeight: "bold", textAlign: "center" })}>{totS}</td>
                  </tr>
                );
              })}
              <tr>
                <td style={td({ background: C.totalWeekRow, fontWeight: "bold" })}>{sec.label}</td>
                {sec.estimated.map((e, qi) => <React.Fragment key={qi}>
                  <td style={td({ background: C.totalWeekRow })} />
                  <td style={td({ background: C.totalWeekRow, textAlign: "center", fontWeight: "bold" })}>{fmtN(e[1])}</td>
                  <td style={td({ background: C.totalWeekRow, textAlign: "center", fontWeight: "bold" })}>{e[0]}</td>
                </React.Fragment>)}
                <td style={td({ background: green, color: C.white, fontWeight: "bold", textAlign: "center" })}>{fmtN(sec.totalRow[1])}</td>
                <td style={td({ background: green, color: C.white, fontWeight: "bold", textAlign: "center" })}>{sec.totalRow[0]}</td>
              </tr>
            </React.Fragment>
          ))}
          <tr>
            <td style={td({ background: green, color: C.white, fontWeight: "bold" })}>GRAND TOTAL</td>
            {grandTotal.slice(0,4).map((g,qi) => <React.Fragment key={qi}>
              <td style={td({ background: green, color: C.white })} />
              <td style={td({ background: green, color: C.white, fontWeight: "bold", textAlign: "center" })}>{fmtN(g[1])}</td>
              <td style={td({ background: green, color: C.white, fontWeight: "bold", textAlign: "center" })}>{g[0]}</td>
            </React.Fragment>)}
            <td style={td({ background: green, color: C.white, fontWeight: "bold", textAlign: "center" })}>{fmtN(grandTotal[4][1])}</td>
            <td style={td({ background: green, color: C.white, fontWeight: "bold", textAlign: "center" })}>{grandTotal[4][0]}</td>
          </tr>
        </tbody>
      </table>
    </LandscapePage>
  );
};

const computeGrandTotal = (sections) => {
  const q = [[0,0],[0,0],[0,0],[0,0]];
  sections.forEach(sec => sec.estimated.forEach((e, qi) => { q[qi][0] += e[0]; q[qi][1] += e[1]; }));
  const annual = q.reduce((a, e) => [a[0]+e[0], a[1]+e[1]], [0,0]);
  return [...q, annual];
};

const RdfPage = ({ year, cfg }) => {
  const sections   = cfg?.sections || RDF_SECTIONS;
  const title      = cfg?.title    || "RWANDA DEFENCE FORCE ANNUAL BLOOD COLLECTION PLAN";
  return <AnnualPlanPage title={title} sections={sections} grandTotal={computeGrandTotal(sections)} year={year} />;
};
const RnpPage = ({ year, cfg }) => {
  const sections   = cfg?.sections   || RNP_SECTIONS;
  const title      = cfg?.title      || "RWANDA NATIONAL POLICE ANNUAL BLOOD COLLECTION PLAN";
  const unitsLabel = cfg?.unitsLabel || "Est.UNITS";
  return <AnnualPlanPage title={title} sections={sections} grandTotal={computeGrandTotal(sections)} year={year} unitsLabel={unitsLabel} />;
};

// ══════════════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ══════════════════════════════════════════════════════════════════════════════
class ABCPReport extends React.Component {
  state = {
    year: 2026,
    showPage: "all",
    viewMode: "both",
    selectedCenterKey: null,
    abcpConfig: null,
    activePlanData: null,
    perfMap: {},
    perfDayMap: {},
    planMap: {},
    centerKeyMap: {},
    userCenterKey: null,
    loadingPerf: false,
    zoom: 100,
    sidebarOpen: false,
    printDialogOpen: false,
    printViewMode: "both",
    excelDialogOpen: false,
    excelViewMode: "both",
    showGuide: false,
  };

  handlePrint = () => {
    this.setState({ printDialogOpen: true });
  };

  handleConfirmPrint = () => {
    const { printViewMode, viewMode, zoom } = this.state;
    const savedViewMode = viewMode;
    const savedZoom = zoom;

    this.setState({ viewMode: printViewMode, zoom: 100, printDialogOpen: false }, () => {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        const el = document.getElementById('abcp-print-area');
        const bodyHTML = el ? el.outerHTML : '';

        const printCSS = [
          '*, *::before, *::after { box-sizing: border-box; print-color-adjust: exact !important; -webkit-print-color-adjust: exact !important; color-adjust: exact !important; }',
          'body { margin: 0; padding: 0; background: #fff; font-family: Arial, Helvetica, sans-serif; }',
          '.portrait-page, .toc-page, .landscape-page { width: 297mm; min-height: 210mm; margin: 0 auto 12px; overflow: visible; background: #fff; }',
          '.page-break { display: block; height: 0; }',
          '@media print {',
          '  @page { size: A4 landscape; margin: 6mm; }',
          '  .portrait-page, .toc-page, .landscape-page { width: 297mm !important; min-height: 0 !important; margin: 0 !important; box-shadow: none !important; overflow: visible !important; }',
          '  .page-break { break-after: page; page-break-after: always; height: 0 !important; display: block !important; }',
          '  table { border-collapse: collapse; break-inside: avoid; page-break-inside: avoid; }',
          '  tr    { break-inside: avoid; page-break-inside: avoid; }',
          '  img   { max-width: 100%; }',
          '}',
        ].join('\n');

        // Use a hidden iframe — no second browser window opens
        const iframe = document.createElement('iframe');
        iframe.style.cssText = 'position:fixed;left:0;top:0;width:297mm;height:210mm;opacity:0;pointer-events:none;z-index:-1;border:0;';
        document.body.appendChild(iframe);

        const iDoc = iframe.contentDocument || iframe.contentWindow.document;
        iDoc.open();
        iDoc.write(
          '<!DOCTYPE html><html><head><meta charset="UTF-8">' +
          '<base href="' + window.location.origin + '/">' +
          '<style>' + printCSS + '</style>' +
          '</head><body>' + bodyHTML + '</body></html>'
        );
        iDoc.close();

        const cleanup = () => {
          this.setState({ viewMode: savedViewMode, zoom: savedZoom });
          setTimeout(() => { if (document.body.contains(iframe)) document.body.removeChild(iframe); }, 500);
        };

        const doPrint = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          cleanup();
        };

        if (iDoc.readyState === 'complete') {
          setTimeout(doPrint, 300);
        } else {
          iframe.onload = () => setTimeout(doPrint, 300);
          setTimeout(doPrint, 1500);
        }
      }));
    });
  };

  _loadConfig = async () => {
    const abcpConfig = await loadConfigAsync(this.state.year);
    this.setState({ abcpConfig });
  };

  _loadActivePlanning = async () => {
    const { year } = this.state;
    try {
      const res = await fetchAbcPlanning(this.props.defaultLanguage, { limit: 100, year });
      const list = (Array.isArray(res) ? res : res?.data) || [];
      // Prefer approved; fall back to latest
      const planning = list.find(p => p.status === "approved") || list[list.length - 1] || null;
      this.setState({ activePlanData: planning?.planData || null });
    } catch (_) {
      this.setState({ activePlanData: null });
    }
  };

  componentDidMount() {
    this._loadConfig();
    this._loadActivePlanning();
    this.fetchData();
    window.addEventListener('abcp-config-updated', this._loadConfig);
    window.addEventListener('abcp-planning-updated', this._loadActivePlanning);
  }

  componentWillUnmount() {
    window.removeEventListener('abcp-config-updated', this._loadConfig);
    window.removeEventListener('abcp-planning-updated', this._loadActivePlanning);
  }

  componentDidUpdate(_, prevState) {
    if (prevState.year !== this.state.year) {
      this._loadConfig();
      this._loadActivePlanning();
      this.fetchData();
    }
  }

  fetchData = async () => {
    const { year } = this.state;
    this.setState({ loadingPerf: true });
    try {
      const user = await getStorage();
      const headers = { Authorization: `Bearer ${user.token}` };

      const [centersData, perfRes, perfDailyRes, planRes] = await Promise.all([
        fetchBloodCenters(this.props.defaultLanguage, { type: "dropdown" }),
        api({
          method: "GET",
          url: `${API_URL}/bloodDonation/abcp-performed`,
          params: { year },
          headers,
        }),
        api({
          method: "GET",
          url: `${API_URL}/bloodDonation/abcp-performed-daily`,
          params: { year },
          headers,
        }),
        api({
          method: "GET",
          url: `${API_URL}/bloodCollectionDailyPlan/abcp-planned`,
          params: { year },
          headers,
        }),
      ]);

      // Build centerKeyMap: short key → center _id
      const centerKeyMap = {};
      (centersData || []).forEach((c) => {
        const key = nameToKey(c.label || c.name || "");
        if (key && c.value) centerKeyMap[key] = String(c.value);
      });

      // Detect user's assigned center (null = superadmin / no restriction)
      const userCenterIds = (user.center || []).map(c => String(c._id || c)).filter(Boolean);
      let userCenterKey = null;
      if (userCenterIds.length > 0) {
        const match = Object.entries(centerKeyMap).find(([, id]) => userCenterIds.includes(id));
        if (match) userCenterKey = match[0];
      }

      // Build perfMap[centerId][monthNum][weekNum] = { sessions, units, siteNames }
      const perfMap = {};
      const perfRows = Array.isArray(perfRes.data) ? perfRes.data : [];
      perfRows.forEach(({ _id, sessions, units, siteNames }) => {
        if (!_id) return;
        const cId = String(_id.center);
        const m = _id.month;
        const w = _id.week;
        if (!perfMap[cId]) perfMap[cId] = {};
        if (!perfMap[cId][m]) perfMap[cId][m] = {};
        perfMap[cId][m][w] = { sessions, units, siteNames: siteNames || [] };
      });

      // Build perfDayMap[centerId][monthNum][dayNum] = { sessions, units, siteNames, siteItems }
      const perfDayMap = {};
      const perfDailyRows = Array.isArray(perfDailyRes.data) ? perfDailyRes.data : [];
      perfDailyRows.forEach(({ _id, sessions, units, siteNames, siteItems }) => {
        if (!_id) return;
        const cId = String(_id.center);
        const m = _id.month;
        const d = _id.day;
        if (!perfDayMap[cId]) perfDayMap[cId] = {};
        if (!perfDayMap[cId][m]) perfDayMap[cId][m] = {};
        perfDayMap[cId][m][d] = { sessions, units, siteNames: siteNames || [], siteItems: siteItems || [] };
      });

      // Build planMap[centerId][monthNum][weekNum] = { sessions, units, siteNames }
      const planMap = {};
      const planRows = Array.isArray(planRes.data) ? planRes.data : [];
      planRows.forEach(({ _id, sessions, units, siteNames }) => {
        if (!_id) return;
        const cId = String(_id.center);
        const m = _id.month;
        const w = _id.week;
        if (!planMap[cId]) planMap[cId] = {};
        if (!planMap[cId][m]) planMap[cId][m] = {};
        planMap[cId][m][w] = { sessions, units, siteNames: siteNames || [] };
      });

      this.setState({ perfMap, perfDayMap, planMap, centerKeyMap, userCenterKey, loadingPerf: false });
    } catch (_) {
      this.setState({ loadingPerf: false });
    }
  };

  handleDownloadCSV = () => {
    const { year, viewMode, perfDayMap, centerKeyMap, abcpConfig, activePlanData } = this.state;
    const centers = [
      { key: "k",  label: "KIGALI"    },
      { key: "b",  label: "BUTARE"    },
      { key: "ko", label: "KARONGI"   },
      { key: "ru", label: "RUHENGERI" },
      { key: "rw", label: "RWAMAGANA" },
    ];

    const showPlanned   = viewMode !== "performed";
    const showPerformed = viewMode !== "planned";

    const centerHeaders = centers.flatMap(c => [
      ...(showPlanned   ? [`${c.label} Plan Sites`, `${c.label} Plan Sess`, `${c.label} Plan Units`] : []),
      ...(showPerformed ? [`${c.label} Perf Sites`,  `${c.label} Perf Sess`,  `${c.label} Perf Units`]  : []),
      ...(showPlanned && showPerformed ? [`${c.label} Rate%`] : []),
    ]);
    const totalHeaders = [
      ...(showPlanned   ? ["Total Plan Sess", "Total Plan Units"] : []),
      ...(showPerformed ? ["Total Perf Sess", "Total Perf Units"] : []),
      ...(showPlanned && showPerformed ? ["Total Rate%"] : []),
    ];
    const rows = [["Month", "Week", "Date", "Day", ...centerHeaders, ...totalHeaders]];

    const monthlyPlan = activePlanData ?? abcpConfig?.monthlyPlan ?? MONTHS_WEEKS;

    MONTHS_ORDER.forEach((month, mIdx) => {
      const monthNum  = mIdx + 1;
      const dailyPlan = abcpConfig?.dailyPlan?.[month] || {};
      const weeks     = (monthlyPlan[month] || []).filter(w => !w.label.startsWith("FIXED"));

      weeks.forEach(w => {
        const match   = w.label.match(/WEEK (\d+)/);
        const weekNum = match ? Number(match[1]) : null;
        if (!weekNum) return;

        getWeekDaysList(month, weekNum, year).forEach(({ date, dayName }) => {
          const dp      = dailyPlan[date] || (!activePlanData ? DAILY_PLAN_2026[month]?.[date] : undefined);
          const holiday = dp?.holiday;
          const noColSet = new Set(dp?.noCol || []);

          let totPlanSess = 0, totPlanUnits = 0, totPerfSess = 0, totPerfUnits = 0;

          const centerCells = centers.flatMap(c => {
            const centerId  = centerKeyMap[c.key];
            const planSites = (dp?.[c.key] || []).map(cleanSite);
            const noCol     = noColSet.has(c.key) && planSites.length === 0;
            const planSess  = noCol ? 0 : (dp?.sess?.[c.key]  || 0);
            const planUnits = noCol ? 0 : (dp?.units?.[c.key] || 0);
            const dayPerf   = centerId ? perfDayMap[centerId]?.[monthNum]?.[date] : null;
            const perfSites = (dayPerf?.siteNames || []).map(cleanSite);
            const perfSess  = dayPerf?.sessions || 0;
            const perfUnits = dayPerf?.units    || 0;
            const rate      = planUnits > 0 ? Math.round(perfUnits / planUnits * 100) + "%" : "—";

            totPlanSess  += planSess;
            totPlanUnits += planUnits;
            totPerfSess  += perfSess;
            totPerfUnits += perfUnits;

            const planSitesStr = holiday
              ? holiday
              : noCol
                ? "No collection"
                : planSites.join(" | ") || "—";

            return [
              ...(showPlanned   ? [planSitesStr, planSess || "—", planUnits || "—"] : []),
              ...(showPerformed ? [perfSites.join(" | ") || "—", perfSess || "—", perfUnits || "—"] : []),
              ...(showPlanned && showPerformed ? [rate] : []),
            ];
          });

          const totalRate = totPlanUnits > 0
            ? Math.round(totPerfUnits / totPlanUnits * 100) + "%"
            : "—";
          const totalCells = [
            ...(showPlanned   ? [totPlanSess || "—", totPlanUnits || "—"] : []),
            ...(showPerformed ? [totPerfSess || "—", totPerfUnits || "—"] : []),
            ...(showPlanned && showPerformed ? [totalRate] : []),
          ];

          rows.push([
            month, w.label, date,
            holiday ? `${dayName} (${holiday})` : dayName,
            ...centerCells, ...totalCells,
          ]);
        });
      });
    });

    const csv = rows
      .map(row => row.map(cell => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(","))
      .join("\n");
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `ABCP-${viewMode}-${year}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  handleDownloadExcel = async () => {
    const { year, excelViewMode, perfDayMap, centerKeyMap, abcpConfig, activePlanData } = this.state;
    this.setState({ excelDialogOpen: false });
    await generateABCPExcel({
      year, viewMode: excelViewMode,
      perfDayMap, centerKeyMap,
      abcpConfig, activePlanData,
      MONTHS_WEEKS, DAILY_PLAN_2026,
      getWeekDaysList, cleanSite,
    });
  };

  render() {
    const { year, showPage, viewMode, selectedCenterKey, abcpConfig, activePlanData, perfMap, perfDayMap, planMap, centerKeyMap, userCenterKey, loadingPerf, zoom, sidebarOpen, printDialogOpen, printViewMode, excelDialogOpen, excelViewMode } = this.state;
    // userCenterKey: auto-locked from user's center assignment (null = superadmin)
    // selectedCenterKey: manual filter from toolbar dropdown (superadmin only)
    const effectiveCenterKey = userCenterKey || selectedCenterKey;

    // activePlanData (from API) takes priority over hardcoded config
    const activePlan = activePlanData ?? abcpConfig?.monthlyPlan;
    // Per-day data (entered in ABCP Preparation) takes priority for summary computation
    const computedSummary = computeSummaryFromDailyPlan(abcpConfig?.dailyPlan)
      || computeSummaryFromPlanData(activePlan);
    const effectiveSummaryCfg = computedSummary
      ? { rows: computedSummary.rows, total: computedSummary.total }
      : abcpConfig?.summary;

    const viewOptions = [
      { label: "All Pages",         value: "all"     },
      { label: "Cover (Page 0)",    value: "cover"   },
      { label: "Contents (Page 1)", value: "contents"},
      { label: "Foreword (Page 2)", value: "foreword"},
      { label: "TOC (Page 3)",      value: "toc"     },
      { label: "Divider (Page 4)",  value: "divider" },
      { label: "Summary (Page 5)",  value: "summary" },
      ...MONTHS_ORDER.map(m => ({ label: m, value: m })),
    ];

    const show = (key) => showPage === "all" || showPage === key;

    const pageList = [
      { value: "cover",    label: "Cover",    pageNum: 0,  landscape: true },
      { value: "contents", label: "Contents", pageNum: 1,  landscape: true },
      { value: "foreword", label: "Foreword", pageNum: 2,  landscape: true },
      { value: "toc",      label: "TOC",      pageNum: 3,  landscape: true },
      { value: "divider",  label: "Divider",  pageNum: 4,  landscape: true },
      { value: "summary",  label: "Summary",  pageNum: 5,  landscape: true },
      ...MONTHS_ORDER.map((m, i) => ({ value: m, label: m.charAt(0) + m.slice(1).toLowerCase(), pageNum: 6 + i * 4, landscape: true })),
    ];
    const currentRealPage = showPage === "all"
      ? 0
      : (pageList.find(p => p.value === showPage)?.pageNum ?? 0);

    const selStyle = { background: "#444", color: "#e8e8e8", border: "1px solid #5a5a5a", borderRadius: 4, padding: "3px 6px", fontSize: 12, cursor: "pointer", outline: "none" };
    const iconBtn  = { background: "none", border: "none", color: "#bbb", cursor: "pointer", padding: "5px 8px", borderRadius: 4, lineHeight: 1, display: "flex", alignItems: "center", transition: "color 0.15s, background 0.15s" };
    const vDivider = <div style={{ width: 1, height: 20, background: "#5a5a5a", margin: "0 3px", flexShrink: 0 }} />;

    const IconDownload = () => (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
      </svg>
    );
    const IconPrint = () => (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 6 2 18 2 18 9"/>
        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
        <rect x="6" y="14" width="12" height="8"/>
      </svg>
    );
    const IconMenu = () => (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="3" y1="6"  x2="21" y2="6"/>
        <line x1="3" y1="12" x2="21" y2="12"/>
        <line x1="3" y1="18" x2="21" y2="18"/>
      </svg>
    );

    return (
      <div>
        {/* Styles — screen sizing + print isolation using visibility pattern */}
        <style>{`
          /* All pages are landscape — portrait-page class is an alias for landscape-page */
          .portrait-page, .toc-page, .landscape-page { box-sizing: border-box; background: #fff; }
          @media screen {
            .portrait-page, .toc-page, .landscape-page {
              width: 100%; min-height: 210mm;
              margin: 0 0 16px 0;
              box-shadow: 0 2px 12px rgba(0,0,0,0.5);
            }
            .abcp-icon-btn:hover { color: #fff !important; background: rgba(255,255,255,0.08) !important; }
          }
          /* ── Responsive toolbar ── */
          .abcp-toolbar { flex-wrap: nowrap; }
          @media (max-width: 900px) {
            .abcp-toolbar { flex-wrap: wrap; gap: 4px !important; padding: 6px 8px !important; }
            .abcp-toolbar-right { margin-left: 0 !important; }
            .abcp-sidebar { width: 90px !important; }
            .abcp-sidebar .thumb-label { display: none; }
          }
          @media (max-width: 600px) {
            .abcp-toolbar select { font-size: 11px !important; padding: 2px 4px !important; }
            .abcp-toolbar span { font-size: 10px !important; }
            .abcp-sidebar { display: none !important; }
          }
          @media print {
            body * { visibility: hidden; }
            #abcp-print-area, #abcp-print-area * { visibility: visible; }
            #abcp-print-area { position: fixed; left: 0; top: 0; width: 100%; height: auto; }
            .abcp-zoom-wrapper { zoom: 1 !important; transform: none !important; overflow: visible !important; }
            * { print-color-adjust: exact !important; -webkit-print-color-adjust: exact !important; color-adjust: exact !important; }
            .portrait-page, .toc-page, .landscape-page {
              width: 297mm !important; min-height: 0 !important;
              margin: 0 !important; box-shadow: none !important;
              overflow: visible !important;
            }
            /* Only .page-break triggers a page break — avoids double-break empty pages */
            .page-break { break-after: page; page-break-after: always; height: 0 !important; display: block !important; }
            table { border-collapse: collapse; break-inside: avoid; page-break-inside: avoid; }
            tr    { break-inside: avoid; page-break-inside: avoid; }
            img   { max-width: 100%; }
          }
        `}</style>

        <div style={{ background: "#525659", borderRadius: 4, display: "flex", flexDirection: "column", height: "calc(100vh - 140px)", minHeight: 400 }}>

          {/* ── Toolbar ── */}
          <div className="no-print abcp-toolbar" style={{ background: "#3c3f41", padding: "5px 10px", display: "flex", alignItems: "center", gap: 4, borderBottom: "1px solid #2a2a2a", flexShrink: 0 }}>

            {/* Sidebar toggle */}
            <button className="abcp-icon-btn" onClick={() => this.setState(p => ({ sidebarOpen: !p.sidebarOpen }))} style={iconBtn} title="Toggle panel">
              <IconMenu />
            </button>
            {vDivider}

            {/* Page counter — real PDF page number / total */}
            <span style={{ color: "#ccc", fontSize: 12, padding: "2px 8px", background: "#3a3a3a", border: "1px solid #555", borderRadius: 4, whiteSpace: "nowrap", letterSpacing: "0.02em" }}>
              {`${showPage === "all" ? 1 : currentRealPage} / ${PDF_TOTAL_PAGES}`}
            </span>
            {vDivider}

            {/* Zoom controls */}
            <button className="abcp-icon-btn" onClick={() => this.setState(p => ({ zoom: Math.max(25, p.zoom - 10) }))} style={iconBtn} title="Zoom out">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>
            </button>
            <span style={{ color: "#ccc", fontSize: 12, minWidth: 44, textAlign: "center", background: "#3a3a3a", border: "1px solid #555", borderRadius: 4, padding: "2px 6px" }}>{zoom}%</span>
            <button className="abcp-icon-btn" onClick={() => this.setState(p => ({ zoom: Math.min(1000, p.zoom + 10) }))} style={iconBtn} title="Zoom in">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            </button>
            {vDivider}

            {/* Year — immediately left of pages select */}
            <select value={year} onChange={e => this.setState({ year: Number(e.target.value) })} style={selStyle}>
              {YEARS.map(y => <option key={y.value} value={y.value}>{y.label}</option>)}
            </select>

            {/* Page view select */}
            <select value={showPage} onChange={e => this.setState({ showPage: e.target.value })} style={{ ...selStyle, maxWidth: 160 }}>
              {viewOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>

            {/* View mode select */}
            <select value={viewMode} onChange={e => this.setState({ viewMode: e.target.value })} style={selStyle}>
              <option value="both">Both</option>
              <option value="planned">Planned only</option>
              <option value="performed">Performed only</option>
            </select>

            {/* RCBT center filter (only shown for superadmin / all-center access) */}
            {!userCenterKey && (
              <select value={selectedCenterKey || ""} onChange={e => this.setState({ selectedCenterKey: e.target.value || null })} style={selStyle}>
                <option value="">All RCBTs</option>
                <option value="k">Kigali RCBT</option>
                <option value="b">Butare RCBT</option>
                <option value="ko">Karongi RCBT</option>
                <option value="ru">Ruhengeri RCBT</option>
                <option value="rw">Rwamagana RCBT</option>
                <option value="rmth">RMTH BB</option>
                <option value="rnp">RNP</option>
              </select>
            )}

            {/* System loading spinner */}
            {loadingPerf && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <Loading className="" />
              </div>
            )}

            {/* Right actions */}
            <div className="abcp-toolbar-right" style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 2 }}>
              {/* ── Excel download button + options popover ── */}
              <div style={{ position: "relative" }}>
                <button className="abcp-icon-btn" onClick={() => this.setState({ excelDialogOpen: true })} style={{ ...iconBtn, padding: "5px 10px", gap: 5, fontSize: 12, color: "#ccc", border: "1px solid #5a5a5a", borderRadius: 4 }} title="Download Excel">
                  <IconDownload /> <span style={{ fontSize: 11 }}>Excel</span>
                </button>

                {excelDialogOpen && (
                  <>
                    <div className="no-print" onClick={() => this.setState({ excelDialogOpen: false })} style={{ position: "fixed", inset: 0, zIndex: 9998 }} />
                    <div className="no-print" style={{ position: "absolute", top: "calc(100% + 6px)", right: 0, zIndex: 9999, background: "#2c2c2c", border: "1px solid #555", borderRadius: 8, padding: "18px 20px", minWidth: 260, boxShadow: "0 8px 32px rgba(0,0,0,0.7)" }}>
                      <h3 style={{ margin: "0 0 14px", color: "#e8e8e8", fontSize: 14, fontWeight: 600 }}>Download Options</h3>

                      <div style={{ marginBottom: 16 }}>
                        <label style={{ display: "block", color: "#aaa", fontSize: 11, marginBottom: 5 }}>What to download</label>
                        <select
                          value={excelViewMode}
                          onChange={e => this.setState({ excelViewMode: e.target.value })}
                          style={{ width: "100%", background: "#444", color: "#e8e8e8", border: "1px solid #666", borderRadius: 4, padding: "6px 10px", fontSize: 13, outline: "none", cursor: "pointer" }}
                        >
                          <option value="both">Both (Planned + Performed)</option>
                          <option value="planned">Planned only</option>
                          <option value="performed">Performed only</option>
                        </select>
                      </div>

                      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                        <button
                          onClick={() => this.setState({ excelDialogOpen: false })}
                          style={{ background: "none", border: "1px solid #555", color: "#ccc", borderRadius: 4, padding: "6px 14px", fontSize: 12, cursor: "pointer" }}
                        >
                          Cancel
                        </button>
                        <button
                          onClick={this.handleDownloadExcel}
                          style={{ background: "#2E75B6", border: "none", color: "#fff", borderRadius: 4, padding: "6px 18px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div style={{ position: "relative" }}>
                <button className="abcp-icon-btn" onClick={this.handlePrint} style={{ ...iconBtn, padding: "5px 10px", gap: 5, fontSize: 12, color: "#ccc", border: "1px solid #5a5a5a", borderRadius: 4 }} title="Print / Save as PDF">
                  <IconPrint /> <span style={{ fontSize: 11 }}>Print</span>
                </button>

                {/* ── Print options popover ── */}
                {printDialogOpen && (
                  <>
                    {/* transparent backdrop to close on outside click */}
                    <div className="no-print" onClick={() => this.setState({ printDialogOpen: false })} style={{ position: "fixed", inset: 0, zIndex: 9998 }} />
                    <div className="no-print" style={{ position: "absolute", top: "calc(100% + 6px)", right: 0, zIndex: 9999, background: "#2c2c2c", border: "1px solid #555", borderRadius: 8, padding: "18px 20px", minWidth: 260, boxShadow: "0 8px 32px rgba(0,0,0,0.7)" }}>
                      <h3 style={{ margin: "0 0 14px", color: "#e8e8e8", fontSize: 14, fontWeight: 600 }}>Print Options</h3>

                      <div style={{ marginBottom: 14 }}>
                        <label style={{ display: "block", color: "#aaa", fontSize: 11, marginBottom: 5 }}>What to print</label>
                        <select
                          value={printViewMode}
                          onChange={e => this.setState({ printViewMode: e.target.value })}
                          style={{ width: "100%", background: "#444", color: "#e8e8e8", border: "1px solid #666", borderRadius: 4, padding: "6px 10px", fontSize: 13, outline: "none", cursor: "pointer" }}
                        >
                          <option value="both">Both (Planned + Performed)</option>
                          <option value="planned">Planned only</option>
                          <option value="performed">Performed only</option>
                        </select>
                      </div>

                      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                        <button
                          onClick={() => this.setState({ printDialogOpen: false })}
                          style={{ background: "none", border: "1px solid #555", color: "#ccc", borderRadius: 4, padding: "6px 14px", fontSize: 12, cursor: "pointer" }}
                        >
                          Cancel
                        </button>
                        <button
                          onClick={this.handleConfirmPrint}
                          style={{ background: "#2E75B6", border: "none", color: "#fff", borderRadius: 4, padding: "6px 18px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}
                        >
                          Print
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* ── Body: sidebar + pages ── */}
          <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>

            {/* Thumbnail sidebar */}
            {sidebarOpen && (
              <div className="abcp-sidebar" style={{ width: 130, background: "#3d3d3d", overflowY: "auto", flexShrink: 0, padding: "12px 8px", borderRight: "1px solid #2a2a2a" }}>
                {pageList.map(pg => {
                  const thumbW = pg.landscape ? 88 : 62;
                  const thumbH = pg.landscape ? 44 : 88;
                  const isActive = showPage === pg.value;
                  return (
                    <div key={pg.value}
                      onClick={() => this.setState({ showPage: pg.value })}
                      style={{ marginBottom: 10, cursor: "pointer", textAlign: "center", opacity: !isActive && showPage !== "all" ? 0.5 : 1 }}
                    >
                      <div style={{
                        width: thumbW, height: thumbH, background: "#fff", margin: "0 auto",
                        border: `2px solid ${isActive ? "#4a9eff" : "#555"}`,
                        borderRadius: 2, display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 9, color: "#aaa", boxShadow: isActive ? "0 0 0 1px #4a9eff" : "0 1px 4px rgba(0,0,0,0.4)",
                      }}>
                        {pg.pageNum}
                      </div>
                      <div className="thumb-label" style={{ color: isActive ? "#4a9eff" : "#aaa", fontSize: 9, marginTop: 3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 110, margin: "3px auto 0" }}>
                        {pg.label}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Main pages area */}
            <div style={{ flex: 1, overflow: "auto", minWidth: 0 }}>
              {/* Spacer sets horizontal scroll space to the scaled page width. zoom is on inner wrapper only — the print area (#abcp-print-area) has no zoom so it prints at 100%. */}
              <div style={{ minWidth: `${297 * zoom * 1.4 / 100}mm`, display: "flex", flexDirection: "column", padding: "16px 16px" }}>
                <div className="abcp-zoom-wrapper" style={{ zoom: zoom * 1.4 / 100, width: "100%" }}>
                  <div id="abcp-print-area">
                    {show("cover")    && <><div id="pg-cover"><CoverPage year={year} cfg={abcpConfig?.cover} /></div><PageBreak /></>}
                    {show("contents") && <><div id="pg-contents"><ContentsPage year={year} cfg={abcpConfig?.contents} /></div><PageBreak /></>}
                    {show("foreword") && <><div id="pg-foreword"><ForewordPage year={year} cfg={abcpConfig?.foreword} /></div><PageBreak /></>}
                    {show("toc")      && <><div id="pg-toc"><TOCPage year={year} cfg={abcpConfig?.toc} /></div><PageBreak /></>}
                    {show("divider")  && <><div id="pg-divider"><SectionDividerPage year={year} cfg={abcpConfig?.divider} /></div><PageBreak /></>}
                    {show("summary")  && <><div id="pg-summary"><SummaryPage year={year} cfg={effectiveSummaryCfg} /></div><PageBreak /></>}
                    {MONTHS_ORDER.map((m, i) => {
                      if (!show(m)) return null;
                      return (
                        <React.Fragment key={m}>
                          <div id={`pg-${m}`}>
                            <MonthPage month={m} year={year} pageNum={6 + i * 4}
                              perfMap={perfMap} perfDayMap={perfDayMap} planMap={planMap}
                              centerKeyMap={centerKeyMap}
                              plannedWeeks={activePlan?.[m] ?? abcpConfig?.monthlyPlan?.[m]}
                              dailyPlanOverride={abcpConfig?.dailyPlan?.[m]}
                              noFallbackDaily={!!activePlanData}
                              userCenterKey={effectiveCenterKey}
                              monthlySummary={effectiveSummaryCfg?.rows?.find(r => r.month === m)}
                              viewMode={viewMode}
                              activeDayData={activePlanData?.[m]}
                            />
                          </div>
                          {showPage === "all" && i < MONTHS_ORDER.length - 1 && <PageBreak />}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* ── Floating help button + anchored guide popover ── */}
        <div className="no-print" style={{ position: "fixed", bottom: 0, right: 0, margin: "1rem", zIndex: 1051 }}>
          {this.state.showGuide && (
            <div style={{
              position: "absolute", bottom: 54, right: 0,
              width: 420, maxHeight: "72vh",
              background: "#fff", borderRadius: 10,
              boxShadow: "0 8px 32px rgba(0,0,0,0.22)",
              border: "1px solid #dee2e6",
              display: "flex", flexDirection: "column",
              overflow: "hidden",
            }}>
              {/* Header */}
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderBottom: "1px solid #dee2e6", background: "#f8f9fa", borderRadius: "10px 10px 0 0", flexShrink: 0 }}>
                <span style={{ fontWeight: 700, fontSize: 14 }}>How to Use the ABCP Report</span>
                <button
                  onClick={() => this.setState({ showGuide: false })}
                  style={{ border: "none", background: "none", fontSize: 20, cursor: "pointer", color: "#888", lineHeight: 1, padding: 0 }}
                >×</button>
              </div>
              {/* Scrollable body */}
              <div style={{ overflowY: "auto", padding: "16px", fontSize: 13, lineHeight: 1.65 }}>

                <p style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--primary-color)", fontWeight: 700, marginBottom: 6 }}>Navigating Pages</p>
                <ol style={{ paddingLeft: 18, marginBottom: 16 }}>
                  <li>Use the <strong>sidebar thumbnail panel</strong> on the left to jump directly to any page (Cover, Contents, Foreword, TOC, Divider, Summary, or any month).</li>
                  <li>Use the <strong>All Pages</strong> dropdown in the toolbar to select a specific page to view.</li>
                  <li>The <strong>page counter</strong> (e.g. <em>6 / 53</em>) shows the real PDF page number and total pages.</li>
                </ol>

                <p style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--primary-color)", fontWeight: 700, marginBottom: 6 }}>View Modes</p>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 16 }}>
                  {[
                    { label: "Both",           desc: "Shows planned sessions alongside recorded (performed) data." },
                    { label: "Planned only",   desc: "Shows only the planned blood collection schedule." },
                    { label: "Performed only", desc: "Shows only recorded performance data from the system." },
                  ].map(({ label, desc }) => (
                    <div key={label} style={{ border: "1px solid #e0e0e0", borderRadius: 6, padding: "8px 10px" }}>
                      <strong style={{ display: "block", marginBottom: 3, fontSize: 12 }}>{label}</strong>
                      <span style={{ fontSize: 11, color: "#555" }}>{desc}</span>
                    </div>
                  ))}
                </div>

                <p style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--primary-color)", fontWeight: 700, marginBottom: 6 }}>Filtering by Blood Center</p>
                <p style={{ marginBottom: 16 }}>
                  Use the <strong>All RCBTs</strong> dropdown to filter the report to a specific blood transfusion center (Kigali, Butare, Karongi, Ruhengeri, or Rwamagana). Selecting a center highlights only that center's columns.
                </p>

                <p style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--primary-color)", fontWeight: 700, marginBottom: 6 }}>Printing the Report</p>
                <ol style={{ paddingLeft: 18, marginBottom: 16 }}>
                  <li>Click the <strong>Print</strong> button in the toolbar (top-right).</li>
                  <li>In the <strong>Print Options</strong> popover, choose what to print: Both, Planned only, or Performed only.</li>
                  <li>Click <strong>Print</strong> — the native browser print dialog will open.</li>
                  <li>Select <strong>Save as PDF</strong> in the print dialog to export a PDF file.</li>
                </ol>

                <p style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: 1, color: "var(--primary-color)", fontWeight: 700, marginBottom: 6 }}>Exporting to Excel</p>
                <p style={{ marginBottom: 12 }}>
                  Click the <strong>Excel</strong> button in the toolbar. Choose the view mode and click <strong>Export</strong>. An <code>.xlsx</code> file will be downloaded containing all months' data.
                </p>

                <div style={{ background: "#fff8e1", border: "1px solid #f59e0b", borderRadius: 6, padding: "8px 12px", display: "flex", gap: 8, alignItems: "flex-start" }}>
                  <span style={{ fontSize: 15, lineHeight: 1.4 }}>⚠</span>
                  <span style={{ fontSize: 11, color: "#92400e", lineHeight: 1.5 }}>
                    <strong>Note:</strong> The report is read-only. To update planning data, use the <em>ABCP Preparation</em> or <em>New ABC Planning</em> tabs.
                  </span>
                </div>

              </div>
            </div>
          )}

          <button
            title="Need help? Use this guide"
            onClick={() => this.setState(prev => ({ showGuide: !prev.showGuide }))}
            style={{
              width: 44, height: 44, borderRadius: "50%",
              backgroundColor: this.state.showGuide ? "#fff" : "var(--primary-color)",
              color: this.state.showGuide ? "var(--primary-color)" : "white",
              border: "2px solid var(--primary-color)",
              boxShadow: "rgba(0,0,0,0.28) 0px 3px 10px",
              cursor: "pointer", fontSize: 22, fontWeight: 700,
              display: "flex", alignItems: "center", justifyContent: "center",
              lineHeight: 1,
            }}
          >?</button>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({ defaultLanguage: state.Language.defaultLanguage });
export default connect(mapStateToProps)(ABCPReport);
